<template>
  <div>
    <div class="search-wrapper">
      <div class="search">
        <span>地区：</span>
        <!-- <Input style="width:80px;" v-model="searchValue.searchArea"></Input> -->
        <Select
          v-model="searchValue.searchArea"
          style="width: 120px;margin-right:5px"
        >
          <Option
            v-for="depart in areaArr"
            :key="depart.id"
            :value="depart.name"
          >{{depart.name}}</Option>
        </Select>
      </div>
      <div class="search">
        <span>供应商名称：</span>
        <Input
          style="width:180px;"
          placeholder="模糊查询"
          v-model="searchValue.searchCompanyName"
        ></Input>
      </div>
      <div class="search">
        <span>项目名称：</span>
        <Input
          style="width:180px;"
          placeholder="模糊查询"
          v-model="searchValue.searchProjectName"
        ></Input>
      </div>
      <div class="search">
        <span>项目简编：</span>
        <Input
          style="width:100px;"
          v-model="searchValue.searchNumAbbr"
        ></Input>
      </div>
      <div class="search">
        <span>项目编号：</span>
        <Input
          style="width:150px;"
          v-model="searchValue.searchNum"
        ></Input>
      </div>
      <div class="search">
        <span>收款方式：</span>
        <Input
          style="width:100px;"
          v-model="searchValue.searchPayType"
        ></Input>
      </div>
      <div class="search">
        <span>售卖时间：</span>
        <DatePicker
          type="daterange"
          style="width: 200px"
          v-model="searchValue.searchPayTime"
          @on-change="selectTimeChange"
        ></DatePicker>
      </div>
      <div class="search">
        <span>报名状态：</span>
        <Select
          style="width:160px;"
          v-model="searchValue.searchStatus"
        >
          <Option
            v-for="item in statusList"
            :value="item.value"
            :key="item.value"
          >{{ item.label }}</Option>
        </Select>
      </div>
      <Button
        type="primary"
        icon="ios-search"
        style="margin: 0 10px;"
        @click="searchEnroll"
      >搜索</Button>
      <Button
        type="success"
        @click="articleChooseVisible = true"
      >报名录入</Button>
      <Button
        type="success"
        @click="exportData('sellFile')"
        style="margin-left:10px;"
      >标书款一览</Button>
      <Button
        type="success"
        @click="exportData('enrollFile')"
        style="margin:0 10px;"
      >售卖文件一览</Button>
    </div>
    <Spin
      :fix="true"
      v-if="pageSpin"
    ></Spin>
    <Table
      :columns="enrollColumns"
      :data="enrollData"
      style="min-width:1750px;"
    ></Table>
    <Page
      ref="page"
      @on-change="pageChange"
      :total="enrollTotalCount"
      show-elevator
      show-total
      style="margin:5px;"
    ></Page>
    <!-- 报名录入 -->
    <Modal
      width="900px"
      v-model="enrollFormVisible"
      :mask-closable="false"
      title="报名录入"
    >
      <div id="input-form">
        <Form
          ref="supplierInputForm"
          :model="supplierInputForm"
          :rules="supplierFormValid"
          :label-width="80"
        >
          <table
            cellspacing="0"
            cellpadding="0"
            border-collapse="collapse"
            style="width:100%;"
          >
            <tr>
              <td class="item-half">
                <FormItem label="项目名称：">
                  <Input
                    v-model="articleData['title']"
                    readonly
                  ></Input>
                </FormItem>
              </td>
              <td class="item-half">
                <FormItem label="项目编号：">
                  <Input
                    v-model="articleData['projectNo']"
                    readonly
                  ></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <FormItem
                  class="project-group"
                  label="所投包组："
                  prop="groupArr"
                  :label-width="90"
                >
                  <CheckboxGroup v-model="supplierInputForm.groupArr">
                    <template v-for="(item,key) in groupList">
                      <Checkbox :label="item.id">
                        <span>包组{{item['groupNo']}}： {{item['groupName']}}</span>
                      </Checkbox>
                    </template>
                  </CheckboxGroup>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem
                  label="公司名称："
                  :label-width="85"
                  prop="companyName"
                  style="width: 350px;"
                >
                  <Input
                    :readonly="importMode"
                    v-model="supplierInputForm.companyName"
                  ></Input>
                </FormItem>
              </td>
              <td>
                <FormItem
                  label="统一社会信用代码："
                  :label-width="135"
                  prop="companyNo"
                  style="width: 350px;"
                >
                  <Input
                    :readonly="importMode"
                    v-model="supplierInputForm.companyNo"
                  ></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <FormItem
                  label="公司地址："
                  :label-width="85"
                  prop="companyAddress"
                  style="width: 700px;"
                >
                  <Input v-model="supplierInputForm.companyAddress"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem
                  class="valid-email"
                  label="电话："
                  prop="companyTel"
                  style="width: 330px;"
                >
                  <Input v-model="supplierInputForm.companyTel"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem
                  class="valid-email"
                  label="邮箱："
                  prop="companyMail"
                  style="width: 330px;"
                >
                  <Input v-model="supplierInputForm.companyMail"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem
                  label="法定代表人："
                  :label-width="95"
                  prop="LegalPerson"
                  style="width: 350px;"
                >
                  <Input v-model="supplierInputForm.LegalPerson"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem
                  class="valid-email"
                  label="电话："
                  prop="LegalPersonTel"
                  style="width: 330px;"
                >
                  <Input v-model="supplierInputForm.LegalPersonTel"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td rowspan="2">
                <FormItem
                  label="项目联系人："
                  :label-width="95"
                  prop="projectContact"
                  style="width: 350px;"
                >
                  <Input v-model="supplierInputForm.projectContact"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem
                  class="valid-email"
                  label="电话："
                  prop="projectPhone"
                  style="width: 330px;"
                >
                  <Input v-model="supplierInputForm.projectPhone"></Input>
                </FormItem>
              </td>
              <!-- <td>
                <FormItem label="传真：" prop="projectFax" style="width: 350px;">
                  <Input v-model="supplierInputForm.projectFax"></Input>
                </FormItem>
              </td> -->
            </tr>
            <tr>
              <!-- <td>
                <FormItem class="valid-email" label="邮箱：" prop="projectMail" style="width: 330px;">
                  <Input v-model="supplierInputForm.projectMail"></Input>
                </FormItem>
              </td> -->
              <!-- <td>
                <FormItem class="valid-email" label="电话：" prop="projectPhone" style="width: 330px;">
                  <Input v-model="supplierInputForm.projectPhone"></Input>
                </FormItem>
              </td> -->
              <td>
                <FormItem
                  label="传真："
                  prop="projectFax"
                  style="width: 350px;"
                >
                  <Input v-model="supplierInputForm.projectFax"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem
                  label="购买文件经办人："
                  :label-width="120"
                  prop="transactor"
                  style="width: 350px;"
                >
                  <Input v-model="supplierInputForm.transactor"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem
                  class="valid-email"
                  label="电话："
                  prop="transactorPhone"
                  style="width: 330px;"
                >
                  <Input v-model="supplierInputForm.transactorPhone"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td>
                <FormItem
                  label="开户行："
                  prop="openBank"
                  style="width: 350px;"
                >
                  <Input v-model="supplierInputForm.openBank"></Input>
                </FormItem>
              </td>
              <td>
                <FormItem
                  label="开户账号："
                  :label-width="85"
                  prop="openAccount"
                  style="width: 350px;"
                >
                  <Input v-model="supplierInputForm.openAccount"></Input>
                </FormItem>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <FormItem
                  label="文件获取方式："
                  :label-width="110"
                  prop="gainMode"
                  style="width: 700px;"
                >
                  <Radio-group v-model="supplierInputForm.gainMode">
                    <Radio label="1">
                      <span>电子光盘</span>
                    </Radio>
                    <Radio label="2">
                      <span>电子光盘+纸质补充文件</span>
                    </Radio>
                    <Radio label="3">
                      <span>电子邮件</span>
                    </Radio>
                    <Radio label="4">
                      <span>其他</span>
                    </Radio>
                  </Radio-group>
                </FormItem>
              </td>
            </tr>
            <tr v-show="supplierInputForm.gainMode === '3'">
              <td colspan="2">
                <FormItem
                  class="valid-email"
                  label="获取文件邮箱："
                  :label-width="110"
                  prop="companyMail"
                  style="width: 330px;"
                >
                  <Input v-model="supplierInputForm.companyMail"></Input>
                </FormItem>
              </td>
            </tr>
          </table>
        </Form>
      </div>
      <div slot="footer">
        <Button
          style="float:left"
          @click="cancelImport"
        >取消导入</Button>
        <Button
          type="success"
          style="float:left"
          @click="companyChooseVisible = true"
        >导入公司</Button>
        <span
          v-if="importMode"
          style="float:left;line-height:40px;color:#ed3f14"
        >(当前为导入公司，锁定公司，如需取消锁定请点击取消导入)</span>
        <Button
          type="error"
          @click="enrollFormVisible=false"
        >关闭</Button>
        <Button
          type="primary"
          @click="inputEnroll"
        >报名录入</Button>
      </div>
    </Modal>
    <!-- 导入公司信息 -->
    <Modal
      width="800px"
      v-model="companyChooseVisible"
      title="导入公司"
    >
      <company-choose @endImport="importCompany"></company-choose>
      <div slot="footer">
        <Button
          type="error"
          @click="companyChooseVisible=false"
        >取消</Button>
      </div>
    </Modal>
    <!-- 导入项目信息 -->
    <Modal
      width="800px"
      v-model="articleChooseVisible"
      title="录入项目选择"
    >
      <Checkbox
        v-model="importPStatus"
        style="margin:5px;color:#ff9900"
        @on-change="changePStatus"
      >没有在官网发布公告情况</Checkbox>
      <article-choose
        @endImport="importArticle"
        v-if="importProjectStatus==='articles'"
      ></article-choose>
      <project-choose
        @endImport="importArticle"
        v-if="importProjectStatus==='projects'"
      ></project-choose>
      <div slot="footer">
        <!-- <Button type="primary" @click="importProjectStatus='projects'" v-if="importProjectStatus==='articles'">项目选择（无公告情况）</Button>
        <Button type="primary" @click="importProjectStatus='articles'" v-if="importProjectStatus==='projects'">公告选择</Button> -->
        <Button
          type="error"
          @click="articleChooseVisible=false"
        >取消</Button>
      </div>
    </Modal>
    <!-- 报名资料详情 -->
    <Modal
      width="1200px"
      v-model="enrollVisible"
    >
      <div class="enroll-files">
        <Card>
          <p slot="title">资料审核文件</p>
          <ul v-if="enrollDbFiles.length > 0">
            <Button type="primary" size="small" @click="downloadFiles">一键下载</Button>
            <li v-for="(file,index) in enrollDbFiles" :key="index">
              <span>{{file.fileName}}</span>
              <Button
                size="small"
                style="margin-left:10px;"
                type="primary"
                @click="viewFile(file)"
              >查看</Button>
            </li>
          </ul>
          <div v-else>无上传资料审核文件</div>
        </Card>
        <Card>
          <p slot="title">报名资料详情（凭证：{{ enrollRepData.id }}）</p>
          <iframe
            :src="fineUrl"
            width="1145"
            height="600"
          ></iframe>
          <div v-if="enrollRepData.gainAddress">邮寄地址：{{ enrollRepData.gainAddress }}</div>
        </Card>
      </div>
      <div slot="footer">
        <Button
          type="error"
          @click="enrollVisible=false"
        >关闭</Button>
        <!-- <Button type="primary" @click="doPass" v-show="thisClickObj.status==0">审核通过</Button> -->
      </div>
    </Modal>
    <!-- 报名费确认 -->
    <Modal
      v-model="enrollPriceShow"
      title="报名费"
      @on-visible-change="cancelExaminePay"
      width="820"
    >
    <div>
      <Tabs value="线上支付" v-model="enrollTab" @on-click="tabsChange" :animated="false">
        <Tab-pane label="线上支付" name="线上支付">
          <Alert type="error" style="margin-top:10px">请确认是'线上支付'方式才能点击报名通过</Alert>
          <Table :columns="paidColumns" :data="orderList" style="margin-bottom:15px"></Table>
          <Form>
            <Row>
              <Col span="12">
                <FormItem
                  label="收款账号："
                  required
                  :label-width="90"
                >
                  <Select
                    style="width:250px"
                    v-model="selectAccount"
                    @on-change="accountChange"
                    placement="top"
                  >
                    <Option
                      v-for="account in bankAccountArr"
                      :value="account.id"
                      :key="account.id"
                    >{{account.xhfCompanyName}}</Option>
                  </Select>
                  <div style="color:#ed4014">（此账号将作为发票的销售方信息）</div>
                </FormItem>
              </Col>
              <Col span="12">
                <div v-if="selectAccountData">
                  <div>账户信息：</div>
                  <div>开户行银行名称：{{selectAccountData.xhfBankName}}</div>
                  <div>开户行银行账号：{{selectAccountData.xhfBankAccount}}</div>
                  <div>公司名称：{{selectAccountData.xhfCompanyName}}</div>
                  <div>公司地址：{{selectAccountData.xhfCompanyAddress}}</div>
                  <div>信用代码：{{selectAccountData.xhfInvoiceTaxNo}}</div>
                  <div>公司电话：{{selectAccountData.xhfTelphone}}</div>
                </div>
              </Col>
            </Row>
          </Form>
        </Tab-pane>
        <Tab-pane label="缴费证明文件" name="缴费证明文件">
          <Card style="margin-top: 15px">
            <div slot="title">供应商缴费证明文件</div>
            <div v-if="paymentFileArr.length>0">
              <div
                v-for="paymentFile in paymentFileArr"
                style="height: 35px;"
              >
                <span class="workbreak">{{ paymentFile.fileName }}</span>
                <Button
                  type="primary"
                  size="small"
                  style="float:right"
                  @click="viewPayment(paymentFile)"
                >查看</Button>
              </div>
            </div>
            <div
              v-else
              style="text-align:center"
            >无上传缴费信息</div>
          </Card>
          <!-- 无公告状态 -->
          <div
            v-if="!articleData.id"
            style="padding:5px;"
          >
            <span>此报名根据项目录入，请输入报名费：</span>
            <Input
              style="width:150px;"
              v-model="articleData.amount"
            ></Input>
          </div>
          <div style="padding: 10px;">
            <span>该项目的报名费为{{articleData["amount"]}}，请确认供应商已付款并选择收款方式</span>
            <div style="margin-top: 4px">
              <Checkbox v-model="isGroupCal" v-if="articleData.id">按包组计算</Checkbox>
              <Checkbox v-model="reEnrollFree" v-if="articleData.id" style="margin-left:20px;">重招免收费</Checkbox>
              <Checkbox @on-change="(val)=>{ isUnion = val}" style="margin-left:20px;">联合体报名</Checkbox>
            </div>
          </div>
          <div>
            <Form inline>
              <Row>
                <Col span="10">
                  <FormItem
                    label="收款方式："
                    required
                    :label-width="120"
                  >
                    <Select
                      v-model="paymentType"
                      style="width: 180px"
                      @on-change="serviceBankChange"
                    >
                      <Option
                        v-for="item in paymentTypes"
                        :value="item.value"
                        :key="item.value"
                      >{{item.value}}</Option>
                    </Select>
                  </FormItem>
                  <FormItem
                    label="收款(售卖)时间："
                    :label-width="120"
                    required
                  >
                    <DatePicker
                      type="datetime"
                      style="width: 180px"
                      v-model="payTimeValue"
                    ></DatePicker>
                    <div style="color:#ed4014">（此时间为收入确认时间）</div>
                  </FormItem>
                  <FormItem
                    label="联合体付款公司："
                    v-show="isUnion"
                    :required = "isUnion"
                    :label-width="120"
                  >
                    <Input
                      style="width:180px;"
                      v-model="companyName"
                    ></Input>
                  </FormItem>
                  <FormItem
                    label="联合体公司代码："
                    v-show="isUnion"
                    :required = "isUnion"
                    :label-width="120"
                  >
                    <Input
                      style="width:180px;"
                      v-model="companyNo"
                    ></Input>
                  </FormItem>
                  <FormItem
                    label="实际付款户名："
                    :label-width="120"
                  >
                    <Input
                      style="width:236px"
                      placeholder="实际付款户名与报名信息户名不同时填入"
                      v-model="realPayAccountName"
                    ></Input>
                  </FormItem>
                  <FormItem
                    label="实际付款账号："
                    :label-width="120"
                  >
                    <Input
                      style="width:236px"
                      placeholder="实际付款账号与报名信息账号不同时填入"
                      v-model="realPayAccount"
                    ></Input>
                  </FormItem>
                </Col>
                <Col span="14">
                  <!-- <FormItem
                    label="收款方式："
                    required
                    :label-width="120"
                  >
                    <Select
                      v-model="paymentType"
                      style="width: 160px"
                      @on-change="serviceBankChange"
                    >
                      <Option
                        v-for="item in paymentTypes"
                        :value="item.value"
                        :key="item.value"
                      >{{item.value}}</Option>
                    </Select>
                  </FormItem> -->
                  <FormItem
                    label="实际到账时间："
                    :label-width="120"
                    required
                    style="margin-bottom:0"
                  >
                    <DatePicker
                      type="datetime"
                      style="width: 180px"
                      v-model="realPayTime"
                    ></DatePicker>
                    <div style="color:#ed4014">（此时间以银行到账，慧收款/支付宝/微信扫码时间填选）</div>
                  </FormItem>
                  <FormItem
                    label="收款账号："
                    required
                    :label-width="120"
                  >
                    <Select
                      style="width:300px"
                      v-model="selectAccount"
                      @on-change="accountChange"
                      placement="top"
                    >
                      <Option
                        v-for="account in bankAccountArr"
                        :value="account.id"
                        :key="account.id"
                      >{{account.xhfCompanyName}}</Option>
                    </Select>
                    <div style="color:#ed4014">（此账号将作为发票的销售方信息）</div>
                    <div v-if="selectAccountData">
                      <div>账户信息：</div>
                      <div>开户行银行名称：{{selectAccountData.xhfBankName}}</div>
                      <div>开户行银行账号：{{selectAccountData.xhfBankAccount}}</div>
                      <div>公司名称：{{selectAccountData.xhfCompanyName}}</div>
                      <div>公司地址：{{selectAccountData.xhfCompanyAddress}}</div>
                      <div>信用代码：{{selectAccountData.xhfInvoiceTaxNo}}</div>
                      <div>公司电话：{{selectAccountData.xhfTelphone}}</div>
                    </div>
                  </FormItem>
                </Col>
              </Row>
            </Form>
          </div>
        </Tab-pane>
      </Tabs>
    </div>
    <div slot="footer">
      <Button @click="enrollPriceShow=false">取消</Button>
      <Button
        :disabled="isPaid"
        type="success"
        @click="setPayment"
      >报名通过</Button>
      <!-- <Button type="warning" @click="setPaymentIn">报名通过（不开发票）</Button> -->
      <Button
      :disabled="isPaid"
        type="error"
        @click="unpassPayment"
      >缴费信息不通过</Button>
    </div>
    </Modal>
    <!-- 审核确认 -->
    <Modal
      v-model="examineConfirmVisible"
      title="审核"
    >
      <Icon type="md-warning" />
      <p>请仔细核对报名信息及上传文件</p>
      <div slot="footer">
        <Button @click="examineConfirmVisible=false">取消</Button>
        <Button
          type="success"
          @click="examinePass"
        >审核通过</Button>
        <Button
          type="error"
          @click="examineUnpass"
        >审核不通过</Button>
      </div>
    </Modal>
    <!-- 订单 -->
    <Modal
      title="缴费记录"
      v-model="ordersVisible"
      width="950px;">
      <div style="font-size:14px;margin-bottom:5px;" v-if="invoiceEnroll.invoiceType">
        <div>
          <div style="display:inline-block;min-width:250px;margin-right:30px;">供应商发票需求：{{invoiceEnroll.invoiceType}}</div>
          <span>发票获取方式：{{invoiceEnroll.invoiceGetMethod}}</span>
        </div>
        <div v-if="invoiceEnroll.invoiceType==='专票'">
          <div style="display:inline-block;min-width:250px;margin-right:30px;">开票资料：<a href="javascript:void(0)" @click="downLoadFile('invoice')">{{invoicePostInfo.file.invoiceFileName}}</a></div>
          <span>一般纳税人证明资料：<a href="javascript:void(0)" @click="downLoadFile('taxpayer')">{{invoicePostInfo.file.taxpayerFileName}}</a></span>
        </div>
        <div v-if="invoiceEnroll.invoiceGetMethod==='到付邮寄'">
          <div>
            <div style="display:inline-block;min-width:250px;margin-right:30px;">邮寄联系人：{{invoicePostInfo.postInfo.contact}}</div>
            <span>联系方式：{{invoicePostInfo.postInfo.phone}}</span>
          </div>
          <div>详细地址：{{invoicePostInfo.postInfo.address}}</div>
        </div>
      </div>
      <Table
        :columns="ordersColumns"
        :data="orderList"
      ></Table>
      <div slot="footer">
        <Button @click="ordersVisible=false">取消</Button>
      </div>
    </Modal>
    <!-- 开票 -->
    <Modal
      title="开票"
      v-model="makeInvoiceVisible"
      width="900px;">
      <invoice
        :isHandle="isHandle"
        :invoicePropData="invoiceData"
        @cancelInvoice="makeInvoiceVisible=false"
        @finishInvoice="finishInvoice"
      ></invoice>
      <div slot="footer"></div>
    </Modal>
    <!-- 邮费 -->
    <Modal
      title="其他费用"
      v-model="postageVisible"
      @on-visible-change="cancelPostage">
      <div style="color:#ed3f14;padding:5px 0;">添加费用后请在发票及退款开出发票</div>
      <Form :label-width="80">
        <FormItem label="费用类型">
          <Select
            v-model="feeType"
            style="width:100px;"
          >
            <Option
              v-for="type in feeTypes"
              :value="type"
            >{{type}}</Option>
          </Select>
        </FormItem>
        <FormItem label="金额">
          <Input
            style="width:100px"
            v-model="extraFee"
          ></Input>元
        </FormItem>
        <FormItem label="收款方式">
          <Select
            v-model="paymentType"
            style="width: 200px"
          >
            <Option
              v-for="item in paymentTypes"
              :value="item.value"
              :key="item.value"
            >{{item.value}}</Option>
          </Select>
        </FormItem>
        <FormItem label="收款账号">
          <Select
            style="width:300px"
            v-model="selectAccount"
            @on-change="accountChange"
          >
            <Option
              v-for="account in bankAccountArr"
              :value="account.id"
              :key="account.id"
            >{{account.xhfCompanyName}}</Option>
          </Select>
          <div style="color:#ed4014">（此账号将作为发票的销售方信息）</div>
          <div v-if="selectAccountData">
            <div>账户信息：</div>
            <div>开户行银行名称：{{selectAccountData.xhfBankName}}</div>
            <div>开户行银行账号：{{selectAccountData.xhfBankAccount}}</div>
            <div>公司名称：{{selectAccountData.xhfCompanyName}}</div>
            <div>公司地址：{{selectAccountData.xhfCompanyAddress}}</div>
            <div>信用代码：{{selectAccountData.xhfInvoiceTaxNo}}</div>
            <div>公司电话：{{selectAccountData.xhfTelphone}}</div>
          </div>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="postageVisible=false">取消</Button>
        <Button
          type="primary"
          @click="setPostageOrder"
        >确定</Button>
      </div>
    </Modal>
    <!-- 公告 -->
    <Modal
      title="公告"
      v-model="articleVisible"
      :width="1000">
      <div v-html="articleContent">

      </div>
      <div slot="footer">
      </div>
    </Modal>
    <!-- 资料修改 -->
    <Modal
      v-model="reviseInfoVisible"
      title="资料修改">
      <Form :label-width="80">
        <FormItem
          label="公司名"
          required
        >
          <Input v-model="reviseInfo.companyName"></Input>
        </FormItem>
        <FormItem
          label="信用代码"
          required
        >
          <Input v-model="reviseInfo.companyNo"></Input>
        </FormItem>
        <FormItem label="地址">
          <Input v-model="reviseInfo.companyAddress"></Input>
        </FormItem>
        <FormItem label="邮箱">
          <Input v-model="reviseInfo.companyMail"></Input>
        </FormItem>
        <FormItem label="项目联系人">
          <Input v-model="reviseInfo.projectContact"></Input>
        </FormItem>
        <FormItem label="联系人电话">
          <Input v-model="reviseInfo.projectPhone"></Input>
        </FormItem>
        <FormItem label="包组">
          <CheckboxGroup v-model="reviseInfo.groupArr">
            <template v-for="(item,key) in groupList">
              <Checkbox :label="item.id">
                <span>包组{{item.groupNo}}：{{item['groupName']}}</span>
              </Checkbox>
            </template>
          </CheckboxGroup>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="reviseInfoVisible=false">取消</Button>
        <Button
          type="primary"
          @click="reviseEnrollInfo"
        >确认</Button>
      </div>
    </Modal>
    <!-- 修改订单信息 -->
    <Modal
      v-model="orderEditVisible"
      title="订单修改">
      <Form
        inline
        :label-width="80"
      >
        <FormItem label="公司名称">
          <Input
            v-model="orderEdit.ghfCompanyName"
            style="width:300px;"
          ></Input>
        </FormItem>
        <FormItem label="信用代码">
          <Input
            v-model="orderEdit.ghfInvoiceTaxNo"
            style="width:300px;"
          ></Input>
        </FormItem>
        <FormItem label="收款方式">
          <Select
            v-model="orderEdit.payType"
            style="width: 200px"
          >
            <Option
              v-for="item in paymentTypes"
              :value="item.value"
              :key="item.value"
            >{{item.value}}</Option>
          </Select>
        </FormItem>
        <FormItem label="收款时间">
          <DatePicker
            v-model="orderEdit.orderTime"
            style="width:150px;"
          ></DatePicker>
        </FormItem>
        <FormItem label="收款金额">
          <Input
            v-model="orderEdit.orderAmount"
            style="width:150px;"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="orderEditVisible=false">取消</Button>
        <Button
          @click="editOrderData"
          type="primary"
        >确定</Button>
      </div>
    </Modal>
    <!-- 备注 -->
    <Modal
      v-model="commentVisible"
      title="备注">
      <Input v-model="enrollComment"></Input>
      <div slot="footer">
        <Button @click="commentVisible=false">取消</Button>
        <Button
          type="primary"
          @click="reviseComment"
        >确定</Button>
      </div>
    </Modal>
    <!-- 退款时间 -->
    <Modal v-model="refundInfoVisible" title="退款">
      <div>退款时间：
        <DatePicker type="datetime" v-model="refundTime"></DatePicker>
      </div>
      <div style="margin-top: 15px">退款原因：
        <RadioGroup v-model="refundReason">
          <Radio label="信息修改">报名信息修改退款</Radio>
          <Radio label="正常退款">项目取消等正常退款</Radio>
        </RadioGroup>
      </div>
      <div slot="footer">
        <Button @click="refundInfoVisible=false">取消</Button>
        <Button @click="directRefund" type="primary">确定</Button>
      </div>
    </Modal>
    <!-- 发票信息 -->
    <Modal v-model="invoiceListVisible" title="发票信息" width="950">
      <Table :columns="invoiceColumns" :data="invoiceList"></Table>
      <!-- 红冲发票 -->
      <Modal v-model="redInvoiceVisible" :transfer="false">
        <div slot="header">
          <span v-if="invoiceInputMode==='录入发票'">录入红冲发票</span>
          <span v-else>电子红冲发票</span>
        </div>
        <div>
          <div
            class="redinvoice-item"
            v-if="invoiceInputMode==='录入发票'"
          >
            <label>红冲发票号码：</label>
            <Input
              v-model="redInvoiceHm"
              style="width:300px;"
              placeholder="红冲发票号码"
            ></Input>
          </div>
          <div
            class="redinvoice-item"
            v-if="invoiceInputMode==='录入发票'"
          >
            <label>红冲开票时间：</label>
            <DatePicker
              type="date"
              style="width: 150px"
              v-model="redInvoiceTime"
            ></DatePicker>
          </div>
          <div class="redinvoice-item">
            <label>开票人：</label>
            <Input
              v-model="redInvoiceMaker"
              style="width:300px;"
              placeholder="开票人姓名"
            ></Input>
          </div>
          <div class="redinvoice-item">
            <label>收款人：</label>
            <Input
              v-model="redInvoicePayee"
              style="width:300px;"
              placeholder="收款人姓名"
            ></Input>
          </div>
          <div class="redinvoice-item">
            <label>复核人：</label>
            <Input
              v-model="redInvoiceCheck"
              style="width:300px;"
              placeholder="复核人姓名"
            ></Input>
          </div>
        </div>
        <div slot="footer">
          <Button @click="redInvoiceVisible=false">取消</Button>
          <Button
            @click="makeRedInvoice"
            type="primary"
          >确定</Button>
        </div>
      </Modal>
      <!-- 修改发票信息 -->
      <Modal
        v-model="invoiceEditVisible"
        title="发票修改" :transfer="false">
        <Form
          inline
          :label-width="80"
        >
          <FormItem label="发票号码">
            <Input
              v-model="invoiceEdit.invoiceHm"
              style="width:100px;"
            ></Input>
          </FormItem>
          <FormItem label="发票时间">
            <DatePicker
              v-model="invoiceEdit.invoiceDate"
              style="width:150px;"
            ></DatePicker>
          </FormItem>
          <FormItem label="发票金额">
            <Input
              v-model="invoiceEdit.invoiceAmount"
              style="width:150px;"
            ></Input>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button @click="invoiceEditVisible=false">取消</Button>
          <Button
            @click="editInvoiceData"
            type="primary"
          >确定</Button>
        </div>
      </Modal>
      <div slot="footer"></div>
    </Modal>
    <!-- 采购文件 -->
    <Modal
      v-model="fileModal"
      @on-visible-change="biddingFile = ''">
      <h3 slot="header">采购文件
        <span style="font-weight: normal;font-size: 12px">(统一在公告挂网位置上传)</span>
      </h3>
      <span style="margin-right: 6px">采购文件：</span>
      <Input v-model="biddingFile.displayName" readonly style="width:300px;margin-right: 5px"></Input>
      <Button type="primary" size="small" @click="downloadBiddingFile('down')" :disabled="!isFileExist">下载</Button>
      <p style="margin-top: 10px">公司邮箱： {{enrollRepData.companyMail}}</p>
      <div slot="footer">
        <Button type="primary" @click="fileModal = false">取消</Button>
        <Button type="primary" @click="downloadBiddingFile('send')">发送</Button>
      </div>
    </Modal>
    <!-- 发送邮件 -->
    <Modal
      v-model="editEmail"
      title="发送邮件">
      <p style="margin-bottom: 10px">邮箱地址： {{enrollRepData.companyMail}}</p>
      <Input v-model="emailContent" type="textarea" :rows="4" placeholder="请输入邮件内容"></Input>
      <div slot="footer">
        <Button type="primary" @click="editEmail = false">取消</Button>
        <Button type="primary" @click="sendEmail">发送</Button>
      </div>
    </Modal>
    <!-- 保证金电子保函 -->
    <Modal
      v-model="editMarginVisible"
      title="保证金">
      <span style="margin-right: 6px">是否提交保证金电子保函：</span>
      <RadioGroup v-model="guarantee">
        <Radio label="否"></Radio>
        <Radio label="是"></Radio>
      </RadioGroup>
      <div slot="footer">
        <Button type="primary" @click="editMarginVisible = false">取消</Button>
        <Button type="primary" @click="marginConfirm">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import userAjax from '@/lib/userAjax'
import CompanyChoose from '@/components/companyChoose'
import ArticleChoose from '@/components/articleChoose'
import ProjectChoose from '@/components/projectChoose'
import axios from 'axios'
import Invoice from '@/components/invoice'
import { fileUtil } from '@/lib/file'
import requestUrls from '@/lib/requestUrls'
import { formatDate, CheckSocialCreditCode } from '@/lib/tool'
import util from '@/lib/util'
import sendMessage from '@/lib/message'
import { getEnrollPermission } from "@/lib/projectPermission"
import { setTimeout } from 'timers'
import { fileUtil as abpFileUtil } from '@/lib/abpfile'
import jszip from 'jszip'
import FileSaver from 'file-saver'
import localFile from '@/lib/localFile'

// 订单状态 1：未支付 2：已支付未开票 3：已支付已开票 4：已退款或已红冲

export default {
  name: 'examineEnroll',
  data() {
    const validateMail = async (rule, value, callback) => {
      if (this.supplierInputForm.gainMode === '3') {
        if (value === '') {
          callback(new Error('不能为空'))
        } else {
          const reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
          if (reg.test(value)) {
            callback()
          } else {
            callback(new Error('邮箱格式不正确'))
          }
        }
      } else {
        callback()
      }
    }
    const refundTime = formatDate()
    return {
      // webUrl: 'http://www.choicelink.cn:8888',
      webUrl: 'http://medical.chinapsp.cn:8888',
      feeTypes: ['邮费', '图纸费', '投标费'],
      feeType: '',
      areaArr: [],
      selectInvoice: '',
      enrollData: [],
      payTimeValue: '',
      realPayTime: '',
      realPayAccountName: '',
      realPayAccount: '',
      companyName: '',
      companyNo: '',
      isGroupCal: false,
      commentVisible: false,
      enrollComment: '',
      invoiceEditVisible: false,
      invoiceEdit: {
        invoiceHm: '',
        invoiceDate: '',
        invoiceAmount: ''
      },
      orderEditVisible: false,
      orderEdit: {
        payType: '',
        orderTime: '',
        orderAmount: '',
        ghfCompanyName: '',
        ghfInvoiceTaxNo: ''
      },
      reviseOrder: {},
      enrollColumns: [
        {
          title: '供应商',
          render: (h, params) => {
            let projectFull = params.row.projectFull.substr(-6)
            if (projectFull.indexOf('ZC') !== -1 && !this.visiblePermission) {
              return h('div', {
                style: {
                  color: 'red'
                }
              }, `* * * * * * * * * * * * * * * * *`)
            } else {
              return h('div', params.row.companyName)
            }
          }
        },
        {
          title: '地区',
          width: 80,
          key: 'district'
        },
        {
          title: '项目编号',
          width: 180,
          key: 'projectFull'
        },
        {
          title: '报名时间',
          key: 'creationTime',
          width: 110,
          render: (h, params) => {
            return h('div', params.row.creationTime.split('T')[0])
          }
        },
        {
          title: '报名状态',
          width: 110,
          render: (h, params) => {
            let style = { color: '#000' }
            switch (params.row.status) {
              case '0':
              case '4':
                style.color = '#ff9900'
                break
              case '1':
                style.color = '#2d8cf0'
                break
              case '2':
              case '5':
                style.color = '#ed3f14'
                break
              case '3':
                style.color = '#19be6b'
                break
            }
            return h('div', {
              style: style
            }, params.row.statusText)
          }
        },
        {
          title: '文件领取方式',
          width: 120,
          render: (h, params) => {
            switch (params.row.gainMode) {
              case '1':
                return h('div', '电子光盘')
              case '2':
                return h('div', '电子光盘+纸质')
              case '3':
                return h('div', '电子邮件')
              case '4':
                return h('div', '其他')
              case '5':
                return h('div', '现场领取')
              case '6':
                return h('Tooltip', {
                  props: {
                    content: params.row.gainAddress,
                    placement: 'top'
                  }
                },[
                  h('div', '邮寄')
                ])
              case '15':
                return h('div', '纸质（现场领取）')
              case '16':
                return h('div', '纸质（邮寄）')
              case '25':
                return h('div', '电子邮件+纸质（现场领取）')
              case '26':
                return h('div', '电子邮件+纸质（邮寄）')
            }
          }
        },
        {
          title: '收款方式',
          width: 90,
          render: (h, params) => {
            let bank = '无'
            if (params.row.ordersDto) {
              let status = params.row.ordersDto.orderStatus
                bank = status == '2' || status == '3' ? params.row.ordersDto.payChannel : '无'
            }
            return h('div', bank)
          }
        },
        {
          title: '售卖时间',
          width: 110,
          render: (h, params) => {
            let time = '无'
            if (params.row.ordersDto && params.row.ordersDto.debitAndCredit !== '贷' && params.row.ordersDto.payTime) {
              time = params.row.ordersDto.payTime.split('T')[0]
            }
            return h('div', time)
          }
        },
        {
          title: '发票',
          width: 80,
          render: (h, params) => {
            let open = '未开'
            if (params.row.ordersDto && params.row.ordersDto.orderStatus === '3') {
              open = '已开'
            }
            return h('div', open)
          }
        },
        {
          title: '保函',
          width: 80,
          render: (h, params) => {
            let open = '否'
            if (params.row.openId === '是') {
              open = '是'
            }
            return h('div', open)
          }
        },
        {
          title: '操作',
          width: 450,
          render: (h, params) => {
            // 根据状态修改按钮
            let renderResult = [true, true, true, true]
            let projectFull = params.row.projectFull.substr(-6)
            switch (params.row.status) {
              case '0':
                renderResult = [false, false, true, true]
                break
              case '1':
                renderResult = [false, true, false, false]
                break
              case '2':
                renderResult = [false, true, true, true]
                break
              case '3':
                renderResult = [false, true, true, false]
                break
              case '4':
                renderResult = [false, true, false, false]
                break
              case '5':
                renderResult = [false, true, false, false]
                break
            }
            let renderArray = [
              h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: renderResult[0] || (projectFull.indexOf('ZC') !== -1 && !this.visiblePermission)
                  },
                  style: {
                    margin: '5px 5px 5px 0'
                  },
                  on: {
                    click: () => {
                      this.showArticle(params.row)
                    }
                  }
                }, '公告'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: renderResult[0] || (projectFull.indexOf('ZC') !== -1 && !this.visiblePermission)
                  },
                  style: {
                    margin: '5px 5px 5px 0'
                  },
                  on: {
                    click: () => {
                      this.showEnrollInfo(params.row)
                    }
                  }
                }, '报名详情'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small',
                    disabled: renderResult[1] || (projectFull.indexOf('ZC') !== -1 && !this.visiblePermission)
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.examineEnroll(params.row)
                    }
                  }
                }, '资料审核'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small',
                    disabled: !(!renderResult[2] || !renderResult[1]) || (projectFull.indexOf('ZC') !== -1 && !this.visiblePermission)
                  },
                  style: {
                    margin: '5px 5px 5px 0'
                  },
                  on: {
                    click: async () => {
                      this.enrollRepData = params.row
                      this.reviseInfo.companyName = params.row.companyName
                      this.reviseInfo.companyNo = params.row.companyNo
                      this.reviseInfo.companyMail = params.row.companyMail
                      this.reviseInfo.companyAddress = params.row.companyAddress
                      this.reviseInfo.projectContact = params.row.projectContact
                      this.reviseInfo.projectPhone = params.row.projectPhone
                      this.reviseInfoVisible = true
                      this.reviseInfo.groupArr = []
  
                      // 获取包组
                      let rep = await ajax.get(requestUrls.ClGroupDb.getPaged, {
                        params: {
                          filter: `projectId == "${params.row.projectId}"`,
                          sorting: 'id',
                          maxResultCount: 500,
                          skipCount: 0
                        }
                      })
                      this.groupList = rep.data.result.items
  
                      // 需等 groupList 变更，否则会出现问题，无法勾选中原有包组
                      setTimeout(() => {
                        if (params.row.groupId.length > 0) {
                          let groupArr = params.row.groupId.split(',')
                          this.reviseInfo.groupArr = groupArr.map(id => {
                            return parseInt(id)
                          })
                        }
                      }, 50)
                    }
                  }
                }, '资料修改'),
                h('Button', {
                  props: {
                    type: 'success',
                    size: 'small',
                    disabled: renderResult[2] || (projectFull.indexOf('ZC') !== -1 && !this.visiblePermission)
                  },
                  style: {
                    margin: '5px 5px 5px 0'
                  },
                  on: {
                    click: () => {
                      this.payEnroll(params.row)
                    }
                  }
                }, '报名费审核'),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    disabled: renderResult[3] || (projectFull.indexOf('ZC') !== -1 && !this.visiblePermission)
                  },
                  style: {
                    margin: '5px 5px 5px 0'
                  },
                  on: {
                    click: () => {
                      this.invoiceAndRefund(params.row)
                    }
                  }
                }, '发票/退款')
              ]),
              h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: renderResult[3] || (projectFull.indexOf('ZC') !== -1 && !this.visiblePermission)
                  },
                  style: {
                    margin: '0 5px 5px 0'
                  },
                  on: {
                    click: () => {
                      this.enrollRepData = params.row
                      this.serviceBankChange()
                      this.postageVisible = true
                    }
                  }
                }, '其他费用'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: projectFull.indexOf('ZC') !== -1 && !this.visiblePermission
                  },
                  style: {
                    margin: '0 5px 5px 0'
                  },
                  on: {
                    click: () => {
                      this.enrollRepData = params.row
                      this.getBiddingFile(params.row)
                    }
                  }
                }, '采购文件'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: projectFull.indexOf('ZC') !== -1 && !this.visiblePermission
                  },
                  style: {
                    margin: '0 5px 5px 0'
                  },
                  on: {
                    click: () => {
                      this.enrollRepData = params.row
                      this.editEmail = true
                    }
                  }
                }, '发送邮件'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: projectFull.indexOf('ZC') !== -1 && !this.visiblePermission
                  },
                  style: {
                    margin: '0 5px 5px 0'
                  },
                  on: {
                    click: () => {
                      this.enrollRepData = params.row
                      this.guarantee = params.row.openId || '否'
                      this.editMarginVisible = true
                    }
                  }
                }, '保证金'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: projectFull.indexOf('ZC') !== -1 && !this.visiblePermission
                  },
                  style: {
                    margin: '0 5px 5px 0'
                  },
                  on: {
                    click: () => {
                      this.enrollRepData = params.row
                      this.enrollComment = params.row.remark
                      this.commentVisible = true
                    }
                  }
                }, '备注'),
              ])
            ]
            return h('div', renderArray);
          }
        }
      ],
      enrollTotalCount: 0,
      paymentVisible: false,
      searchValue: {
        searchNum: '',
        searchStatus: '',
        searchArea: '',
        searchCompanyName: '',
        searchNumAbbr: '',
        searchPayType: '',
        searchPayTime: '',
        searchProjectName: ''
      },
      statusList: [
        {
          value: '0',
          label: '资料待审核'
        },
        {
          value: '2',
          label: '资料审核不通过'
        },
        {
          value: '1',
          label: '待供应商缴费'
        },
        {
          value: '4',
          label: '缴费待审核'
        },
        {
          value: '5',
          label: '缴费审核不通过'
        },
        {
          value: '3',
          label: '报名成功'
        },
        {
          value: '',
          label: '全部'
        }
      ],
      supplierInputForm: {
        groupArr: [],
        companyName: '',
        companyNo: '',
        companyAddress: '',
        companyTel: '',
        companyMail: '',
        legalPerson: '',
        LegalPersonTel: '',
        projectContact: '',
        projectPhone: '',
        projectMail: '',
        projectFax: '',
        transactor: '',
        transactorPhone: '',
        openBank: '',
        openAccount: '',
        gainMode: '',
        gainEmail: ''
      },
      supplierFormValid: {
        groupArr: [
          { required: true, type: 'array', min: 1, message: '不能为空', trigger: 'change' }
        ],
        companyName: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        companyNo: [
          { required: true, message: '不能为空', trigger: 'blur' },
          { pattern: /^[^\u4e00-\u9fa5]*$/, message: '信用代码不能包含中文', trigger: 'blur' }
        ],
        companyTel: [
          { type: 'string', pattern: /(^(\d{3,4}-)?\d{7,8})$|(1[0-9]{10}$)/, message: '电话格式不正确', trigger: 'blur' }
        ],
        companyMail: [
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ],
        LegalPersonTel: [
          { type: 'string', pattern: /(^(\d{3,4}-)?\d{7,8})$|(1[0-9]{10}$)/, message: '电话格式不正确', trigger: 'blur' }
        ],
        projectPhone: [
          { type: 'string', pattern: /(^(\d{3,4}-)?\d{7,8})$|(1[0-9]{10}$)/, message: '电话格式不正确', trigger: 'blur' }
        ],
        projectMail: [
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ],
        transactorPhone: [
          { type: 'string', pattern: /(^(\d{3,4}-)?\d{7,8})$|(1[0-9]{10}$)/, message: '电话格式不正确', trigger: 'blur' }
        ],
        // openAccount: [
        //   { required: true, message: '不能为空', trigger: 'blur' }
        // ],
        // openBank: [
        //   { required: true, message: '不能为空', trigger: 'blur' }
        // ],
        companyMail: [
          { validator: validateMail, trigger: 'blur' }
        ],
      },
      enrollFormVisible: false,
      companyChooseVisible: false,
      importMode: false,
      importProjectStatus: 'articles',
      importPStatus: false,
      groupList: [],
      importCompanyId: '',
      fineUrl: '',
      enrollVisible: false,
      enrollDbFiles: [],
      articleChooseVisible: false,
      articleData: {},
      enrollPriceShow: false,
      enrollRepData: {},
      invoiceInputMode: '电子发票',
      paymentTypes: [
        { value: '现金' },
        { value: '建设银行' },
        { value: '光大银行' },
        { value: '农业银行' },
        { value: '工商银行' },
        { value: '中国银行' },
        { value: '广发银行' },
        { value: 'POS' },
        { value: '支付宝' },
        { value: '微信' },
        { value: '慧收款' },
        { value: '中招联' },
      ],
      paymentType: '',
      examineConfirmVisible: false,
      currentPage: 1,
      makeInvoiceVisible: false,
      invoiceData: {},
      orderList: [],
      ordersVisible: false,
      ordersColumns: [
        {
          title: '订单号',
          key: 'orderNo'
        },
        {
          title: '金额',
          key: 'orderAmountTotal',
          width: 85
        },
        {
          title: '类型',
          key: 'orderType',
          width: 75,
        },
        {
          title: '收款时间',
          width: 100,
          render: (h, params) => {
            let time = '未知时间'
            if (!!params.row.payTime) {
              time = params.row.payTime.split('T')[0]
            }
            return h('div', time)
          }
        },
        {
          title: '收款方式',
          width: 85,
          render: (h, params) => {
            let payChannel = '无'
            if (!!params.row.payChannel) {
              payChannel = params.row.payChannel
            }
            return h('div', payChannel)
          }
        },
        {
          title: '状态',
          width: 120,
          render: (h, params) => {
            let status = '未知状态'
            switch (params.row.orderStatus) {
              case '0':
                status = '退款订单'
                break
              case '1':
                status = '未收款'
                break
              case '2':
                status = '已收款未开票'
                break
              case '3':
                status = '已收款已开票'
                break
              case '4':
                status = '已退款'
                break
            }
            return h('div', status)
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 300,
          render: (h, params) => {
            let display = 'none'
            if (this.financialEditPermission) {
              display = 'inline-block'
            }
            let operateArray = [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.makeInvoice(params.row)
                  }
                }
              }, '开票'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.showInvoice(params.row)
                  }
                }
              }, '发票信息'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                style: {
                  marginRight: '5px',
                },
                on: {
                  click: () => {
                    this.refund(params.row)
                  }
                }
              }, '退款'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: true
                },
                style: {
                  marginRight: '5px',
                },
              }, '已退款'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginLeft: '5px',
                  display: display
                },
                on: {
                  click: () => {
                    this.orderEdit.payType = ''
                    this.orderEdit.orderTime = ''
                    this.orderEdit.orderAmount = ''
                    this.orderEdit.ghfCompanyName = ''
                    this.orderEdit.ghfInvoiceTaxNo = ''

                    this.reviseOrder = params.row
                    console.log(this.reviseOrder)
                    this.orderEdit.ghfCompanyName = params.row.ghfCompanyName
                    this.orderEdit.ghfInvoiceTaxNo = params.row.ghfInvoiceTaxNo
                    this.orderEdit.payType = params.row.payChannel
                    this.orderEdit.orderTime = formatDate(params.row.payTime)
                    this.orderEdit.orderAmount = params.row.orderAmountTotal
                    this.orderEditVisible = true
                  }
                }
              }, '单改')
            ]
            let resultArray = []
            switch (params.row.orderStatus) {
              // 红冲
              case '0':
                resultArray = operateArray.slice(0).splice(4, 1)
                break
              // 未开票未支付
              case '1':
                break
              // 未开票已支付
              case '2':
                resultArray = operateArray.slice(0).splice(0, 3).concat(operateArray.slice(0).splice(4, 1))
                break
              // 已开票已支付
              case '3':
                resultArray = operateArray.slice(0).splice(0, 3).concat(operateArray.slice(0).splice(4, 1))
                break
              // 已红冲或已退款
              case '4':
                resultArray = operateArray.slice(0).splice(0, 2).concat(operateArray.slice(0).splice(3, 2))
                break
            }
            return h('div', resultArray);
          }
        }
      ],
      invoiceEnroll: {},
      redInvoiceVisible: false,
      redInvoiceHm: '',
      redInvoiceMaker: '',
      redInvoiceTime: '',
      redInvoicePayee: '唐惠英',
      redInvoiceCheck: '何梓豪',
      orderData: {},
      paymentFileArr: [],
      makeInvoiceType: '',
      isHandle: false,
      bankAccountArr: [],
      selectAccount: '',
      selectAccountData: '',
      postageVisible: false,
      extraFee: '',
      pageSpin: false,
      extraQuery: {
        rolePermission: ''
      },
      articleContent: '',
      articleVisible: false,
      reviseInfoVisible: false,
      reviseInfo: {
        companyName: '',
        companyNo: '',
        companyMail: '',
        companyAddress: '',
        groupArr: [],
        projectContact: '',
        projectPhone: ''
      },
      // financialEditPermission: false,
      reEnrollFreeAmount: 0,
      reEnrollFree: false,
      sentEmail: false,
      isUnion: false,
      refundInfoVisible: false,
      refundTime: refundTime,
      invoiceList: [],
      invoiceListVisible: false,
      invoiceColumns: [
        {
          title: '发票号码',
          key: 'invoiceHm',
          width: 95
        },
        {
          title: '发票金额',
          key: 'invoiceAmount'
        },
        {
          title: '开票时间',
          width: 100,
          key: 'invoiceTime',
          render: (h, params) => {
            let time = '无开票时间'
            if (params.row.invoiceTime) {
              time = formatDate(params.row.invoiceTime).split(' ')[0]
            }
            return h('div', time)
          }
        },
        {
          title: '类型',
          key: 'inputMode',
          width: 85
        },
        {
          title: '种类',
          width: 60,
          render: (h, params) => {
            let invoiceType = {
              '1': '蓝票',
              '2': '红票'
            }
            return h('div', invoiceType[params.row.invoiceType])
          }
        },
        {
          title: '税率',
          key: 'taxRate',
          width: 65
        },
        {
          title: '开票人',
          key: 'kpr',
          width: 75
        },
        {
          title: '状态',
          key: 'status',
          width: 75,
          render: (h, params) => {
            let status = '其他状态'
            if (params.row.status == 20) {
              status = '开票中'
            }
            if (params.row.status == 21) {
              status = '签章中'
            }
            if (params.row.status == 24) {
              status = '签章失败'
            }
            if (params.row.status == 3) {
              status = '已作废'
            }
            if (params.row.status == 31) {
              status = '作废中'
            }
            if (params.row.status == 22) {
              status = '失败'
            }
            if (params.row.invoiceHm || params.row.status == 2) {
              status = '成功'
            }
            return h('span', status)
          }
        },
        {
          title: '操作',
          width: 270,
          render: (h, params) => {
            let display = 'none'
            let Nndisplay = 'none'
            if (this.financialEditPermission) {
              display = 'inline-block'
            }
            if (this.newInvoicePermission) {
              Nndisplay = 'inline-block'
            }
            return h('div', [
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  marginRight: '5px',
                  marginTop: '5px',
                },
                on: {
                  click: () => {
                    if (params.row.inputMode === '电子发票') {
                      if (params.row.pdfUrl) {
                        window.open(params.row.pdfUrl)
                        return
                      }
                      this.$Message.info('暂无发票下载链接')
                      return
                    }
                    this.$Message.info('非电子发票')
                  }
                }
              }, '下载'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: (params.row.invoiceType == '2' || params.row.isEnabled) ? true : false
                },
                style: {
                  marginRight: '5px',
                  marginTop: '5px',
                },
                on: {
                  click: () => {
                    this.selectInvoice = params.row
                    if (params.row.inputMode === '录入发票' || params.row.inputMode === '电子发票') {
                      this.invoiceInputMode = params.row.inputMode
                      this.redInvoiceVisible = true
                    }
                  }
                }
              }, '红冲'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px',
                  marginTop: '5px',
                },
                on: {
                  click: () => {
                    this.sendInvoiceMessage(params.row, this.orderData, 'mail')
                  }
                }
              }, '邮箱通知'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px',
                  marginTop: '5px',
                },
                on: {
                  click: () => {
                    this.sendInvoiceMessage(params.row, this.orderData, 'phone')
                  }
                }
              }, '短信通知'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  display: Nndisplay,
                  marginRight: '5px',
                  marginTop: '5px',
                },
                on: {
                  click: async () => {
                    if (params.row.invoiceSource !== '诺诺') {
                      this.$Message.info('此发票无需更新状态')
                      return
                    }
                    this.$Spin.show()
                    let rep = await ajax.post(requestUrls.orderInvoice.NnQueryInvoice, {
                      id: params.row.id
                    })
                    this.$Spin.hide()
                    if (rep.data.success) {
                      // 刷新当前发票
                      const newData = [...this.invoiceList]
                      const target = newData.filter(item => item.id === rep.data.result.id)[0]
                      if (target) {
                        // { ...target } = {...rep.data.result}
                        newData[params.index] = rep.data.result
                        this.invoiceList = newData
                      }
                      this.$Message.success('更新成功')
                    }
                  }
                }
              }, '更新状态'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  display: display,
                  marginTop: '5px',
                },
                on: {
                  click: async () => {

                    if (params.row.inputMode === '电子发票') {
                      this.$Message.error('电子发票无法修改')
                      return
                    }

                    this.invoiceEdit.invoiceHm = ''
                    this.invoiceEdit.invoiceDate = ''
                    this.invoiceEdit.invoiceAmount = ''
                    this.selectInvoice = ''

                    this.selectInvoice = params.row
                    this.invoiceEdit.invoiceHm = params.row.invoiceHm
                    this.invoiceEdit.invoiceAmount = params.row.invoiceAmount
                    this.invoiceEdit.invoiceDate = formatDate()
                    if (params.row.invoiceTime) {
                      this.invoiceEdit.invoiceDate = formatDate(params.row.invoiceTime)
                    }

                    this.invoiceEditVisible = true
                  }
                }
              }, '票改'),
            ])
          }
        }
      ],
      refundReason: '',
      enrollTab: '线上支付',
      paidColumns: [],
      fileModal: false,
      biddingFile: {},
      editEmail: false,
      emailContent: '',
      confirmServeCharge: false,
      editMarginVisible: false,
      guarantee: '否'
    }
  },
  async mounted() {
    this.initEnroll()
    // 获取地区
    let areaRep = await ajax.get(requestUrls.CLDistrict.GetList)
    this.areaArr = []
    if (areaRep.data.success && areaRep.data.result.items.length > 0) {
      this.areaArr = areaRep.data.result.items
    }
    this.paidColumns = this.ordersColumns.slice(0, -1)
  },
  computed: {
    financialEditPermission() {
      return this.$store.getters['session/hasRoles']('财务流编辑')
    },
    invoicePermission() {
      return this.$store.getters['session/hasRoles']('电子发票员') || this.$store.getters['session/hasRoles']('深圳电子发票')
    },
    newInvoicePermission() {
      const permission = this.$store.getters['session/hasRoles']('深圳电子发票')
      if (permission) {
        this.redInvoicePayee = '许娜'
        this.redInvoiceCheck = '曹丹'
      }
      return this.$store.getters['session/hasRoles']('深圳电子发票')
    },
    invoicePostInfo() {
      if (this.invoiceEnroll.invoicePostInfo) {
        return JSON.parse(this.invoiceEnroll.invoicePostInfo)
      }
      return {
        file: '',
        postInfo: ''
      }
    },
    isFileExist() {
      return this.biddingFile.displayName ? true : false
    },
    isPaid() {
      if (this.enrollTab == '缴费证明文件') {
        // 检查已有订单
        let order = this.orderList.filter(item => (item.orderStatus == '2'&&item.orderType == '报名') || (item.orderStatus == '3'&&item.orderType == '报名'))
        return order.length > 0
      }
    },
    visiblePermission() {
      let roleNames = this.$store.state.session.roleNames
      let a = roleNames.indexOf('分公司负责人') !== -1
      let b = roleNames.indexOf('会务人员') !== -1
      let c = roleNames.toString().indexOf('财务') !== -1
      return a || b || c
    }
  },
  watch: {
    '$route'() {
      if (this.$route.name === 'examineEnroll') {
        this.changeEnroll(this.currentPage, this.searchValue)
      }
    },
    // 清空报名录入数据
    enrollFormVisible(val) {
      if (!val) {
        this.supplierInputForm.groupArr = []
        this.importMode = false
        this.supplierInputForm = {
          groupArr: [],
          companyName: '',
          companyNo: '',
          companyAddress: '',
          companyTel: '',
          companyMail: '',
          legalPerson: '',
          LegalPersonTel: '',
          projectContact: '',
          projectPhone: '',
          projectMail: '',
          projectFax: '',
          transactor: '',
          transactorPhone: '',
          openBank: '',
          openAccount: '',
          gainMode: '',
          gainEmail: ''
        }
      }
    },
    isGroupCal(val) {
      let length = this.enrollRepData.groupId.split(',').length
      if (val) {
        this.articleData.amount = this.articleData.amount * length
      } else {
        this.articleData.amount = this.articleData.amount / length
      }
    },
    reEnrollFree(val) {
      if (val) {
        // 记录未置零之前的金额
        this.reEnrollFreeAmount = this.articleData.amount
        this.articleData.amount = 0
      } else {
        this.articleData.amount = this.reEnrollFreeAmount
      }
    },
    enrollPriceShow(val) {
      if(!val) this.confirmServeCharge = false
    }
  },
  methods: {
    handleEnroll (val) {
      // 限制进入4.0立项
      this.$Modal.confirm({
        title: '温馨提示',
        content: '报名录入功能已转移到采联业务系统4.0，请前往采联业务系统4.0处理。',
        cancelText: '取消',
        okText: '立即前往',
        onOk: () => {
          if (isWeiXin()) {
            window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
          } else {
            window.open('https://qy.choicelink.cn:8440')
          }
        }
      })
      return
      this.articleChooseVisible = true
    },
    async downLoadFile(fileType) {
      try {
        this.$Spin.show()
        let imgFormat = ['jpg', 'jpeg', 'png']
        let pdfFormat = ['pdf']
        let type = ''
        let fileUrl = ''
        if (fileType === 'invoice') {
          type = this.invoicePostInfo.file.invoiceFileName.split('.')
          type = type[type.length - 1]
          fileUrl = await abpFileUtil.downLoadBlob(this.invoicePostInfo.file.invoiceFileId)
        }
        if (fileType === 'taxpayer') {
          type = this.invoicePostInfo.file.taxpayerFileName.split('.')
          type = type[type.length - 1]
          fileUrl = await abpFileUtil.downLoadBlob(this.invoicePostInfo.file.taxpayerFileId)
        }
        this.$Spin.hide()
        if (imgFormat.indexOf(type) !== -1) {
          this.$showImage(fileUrl)
        }
        if (pdfFormat.indexOf(type) !== -1) {
          window.open('pdf/web/viewer.html?file=' + fileUrl)
        }
      } catch(err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('获取图片失败')
      }
    },
    accountChange(val) {
      for (let i = 0; i < this.bankAccountArr.length; i++) {
        if (this.bankAccountArr[i].id === val) {
          this.selectAccountData = this.bankAccountArr[i]
          break
        }
      }
    },
    async getBankAccount(area = '', bankName = '') {
      // 获取项目所属分子公司
      let req = await ajax.get(`/api/services/app/ClProjectDb/GetById?id=${this.enrollRepData.projectId}`)
      let companyName = req.data.result.companyName
      let filter = ''
      let areaFilter = area ? ` and (district=="${area}" or xhfCompanyName=="采联国际招标采购集团有限公司" or xhfCompanyName=="广东采联采购科技有限公司") ` : ''
      let bankNameFilter = bankName ? ` and xhfBankName.contains("${bankName}")` : ''
      if (companyName.indexOf('分公司') != -1) {
        filter = areaFilter + bankNameFilter + ` and (cName == "${companyName}" or xhfCompanyName=="采联国际招标采购集团有限公司" or xhfCompanyName=="广东采联采购科技有限公司")`
      } else if (companyName.indexOf('采联采购招标有限公司') != -1){
        filter = areaFilter + bankNameFilter + ` and cName == "${companyName}"`
      } else {
        filter = areaFilter + bankNameFilter + ` and (cName == "${companyName}" or xhfCompanyName=="采联国际招标采购集团有限公司" or xhfCompanyName=="广东采联采购科技有限公司")`
      }
      filter = filter.slice(5)
      let rep = await ajax.get(requestUrls.bankAccount.getAll, {
        params: {
          filter: filter
        }
      })
      if (rep.data.success) {
        this.bankAccountArr = rep.data.result.items
      }
    },
    serviceBankChange() {
      let paymentType = ''
      if (this.paymentType === '广发银行' || this.paymentType === '建设银行') {
        paymentType = this.paymentType
      }
      this.getBankAccount(this.enrollRepData.district, paymentType)
    },
    async initEnroll() {
      this.pageSpin = true
      let rep = await ajax.get(requestUrls.enroll.getPaged, {
        params: {
          maxResultCount: 10,
          skipCount: 0,
          sorting: 'e.creationTime desc',
          filter: this.extraQuery.rolePermission.slice(5)
        }
      })
      this.pageSpin = false
      if (rep.data.success) {
        this.enrollData = this.filterData(rep.data.result.items)
        this.enrollTotalCount = rep.data.result.totalCount
      }
    },
    async changeEnroll(page, { searchNum, searchStatus, searchArea, searchCompanyName, searchNumAbbr, searchPayType, searchPayTime, searchProjectName }) {
      let dbSearNum = !searchNum ? '' : ` and e.projectFull.Contains("${searchNum}")`
      let dbSearNumAbbr = !searchNumAbbr ? '' : ` and e.projectShort.Contains("${searchNumAbbr}")`
      let dbSearArea = !searchArea ? '' : ` and e.district.Contains("${searchArea}")`
      let dbSearStatus = (!searchStatus && searchStatus !== '0') ? '' : ` and e.status == "${searchStatus}"`
      let dbSearCompanyName = !searchCompanyName ? '' : ` and e.companyName.Contains("${searchCompanyName}")`
      let dbSearPayType = !searchPayType ? '' : ` and o.payChannel.Contains("${searchPayType}")`
      let dbSearProjectName = !searchProjectName ? '' : ` and p.projectName.contains("${searchProjectName}")`

      let dbSearPayTime = ''
      if (searchPayTime.length > 0 && searchPayTime[0] !== '') {
        let startTime = formatDate(searchPayTime[0])
        let endTime = formatDate(searchPayTime[1])
        dbSearPayTime = ` and o.payTime >= "${startTime}" and o.payTime <= "${endTime}"`
      }
      let filterData = dbSearNum + dbSearArea + dbSearStatus + dbSearCompanyName + dbSearNumAbbr + dbSearPayType + dbSearPayTime + dbSearProjectName + this.extraQuery.rolePermission
      this.pageSpin = true
      let rep = await ajax.get(requestUrls.enroll.getPaged, {
        params: {
          maxResultCount: 10,
          skipCount: (page - 1) * 10,
          filter: filterData.slice(5),
          sorting: 'e.creationTime desc'
        }
      })
      this.pageSpin = false
      if (rep.data.success) {
        this.enrollData = this.filterData(rep.data.result.items)
        this.enrollTotalCount = rep.data.result.totalCount
        if (page === 1) {
          this.$refs.page.currentPage = 1
        }
      }
    },
    pageChange(page) {
      this.currentPage = page
      this.changeEnroll(page, this.searchValue)
    },
    searchEnroll() {
      this.currentPage = 1
      this.changeEnroll(1, this.searchValue)
    },
    filterData(data = []) {
      // 拷贝data
      let dataCy = JSON.parse(JSON.stringify(data))
      dataCy.forEach(item => {
        // item.creationTime = item.creationTime.replace('T', ' ')
        switch (item.status) {
          case '0':
            item.statusText = '资料待审核'
            break
          case '1':
            item.statusText = '待供应商缴费'
            break
          case '2':
            item.statusText = '资料审核不通过'
            break
          case '3':
            item.statusText = '报名成功'
            break
          case '4':
            item.statusText = '缴费待审核'
            break
          case '5':
            item.statusText = '缴费审核不通过'
            break
          default:
            item.statusText = '状态出错，请联系相关人员'
        }
      })
      return dataCy
    },
    async showEnrollInfo(article) {
      this.enrollRepData = article
      if (article.articles && article.articles.isInternational) { // 国际竞赛
        this.fineUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=%5B56fd%5D%5B9645%5D%5B7ade%5D%5B8d5b%5D%2FGJJS_ApplicationFormReport.cpt&formid=${article.id}`
        this.enrollVisible = true
      } else if (article.articles && article.articles.ext2 === '74170') { // 市场调研
        this.fineUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=%E5%B8%82%E5%9C%BA%E8%B0%83%E7%A0%94/CGZX_ApplicationFormReport.cpt&formid=${article.id}&userid=${article.creatorUserId}&npid=${article.projectId}`
        this.enrollVisible = true
      } else {
        this.fineUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2FRegistrationForm.cpt&Id=${article.id}`
        if (article.articles && article.articles.isFillBrand) {
          this.fineUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2FGD_RegistrationForm.cpt&Id=${article.id}`
        }
        this.enrollVisible = true
        let rep = await ajax.get(requestUrls.dbFile.getPaged, {
          params: {
            filter: `objectId.Contains("${article.id}")`,
            maxResultCount: 200,
            skipCount: 0
          }
        })
        this.enrollDbFiles = []
        if (rep.data.success) {
          this.enrollDbFiles = rep.data.result.items
        }
      }
    },
    async payEnroll(enroll) {
      this.spinShow('正在获取报名费审核资料..')      
      if (enroll.articles) {
        this.articleData = enroll.articles
      } else {
        this.articleData = {
          amount: ''
        }
      }
      this.enrollRepData = enroll
      await this.getOrders(enroll)
      // 过滤订单
      this.orderList = this.orderList.filter(item => item.payChannel == '微信' || item.payChannel == '支付宝')
      this.companyName = enroll.companyName
      this.companyNo = enroll.companyNo
      this.serviceBankChange()
      // 查找缴费审核文件
      let rep = await ajax.get(requestUrls.dbFile.getPaged, {
        params: {
          maxResultCount: 100, // 一次全部获取
          skipCount: 0,
          filter: `objectId == "${enroll.id}" and fileType == "报名费"`
        }
      })
      if (rep.data.success) {
        this.paymentFileArr = rep.data.result.items
      }
      this.$Spin.hide()
      this.enrollPriceShow = true
    },
    async viewPayment(file) {
      this.spinShow('正在获取文件，请稍候')
      let fileUrl = await fileUtil.downLoad(file.ossId)
      this.$Spin.hide()
      this.$showImage(fileUrl)
    },
    // 加载过程
    spinShow(text) {
      this.$Spin.show({
        render: (h) => {
          return h('div', [
            h('Icon', {
              'class': 'demo-spin-icon-load',
              props: {
                type: 'ios-loading',
                size: 18
              }
            }),
            h('div', text)
          ])
        }
      })
    },
    examineEnroll(enroll) {
      this.enrollRepData = enroll
      this.examineConfirmVisible = true
    },
    async viewFile(file) {
      this.spinShow('正在获取文件，请稍候..')
      let rep = await axios.get(this.webUrl + "/AliOSS/GetDownUrl", {
        params: {
          id: file.ossId
        }
      })
      this.$Spin.hide()
      if (file.fileName.indexOf('jpg') !== -1 || file.fileName.indexOf('png') !== -1) {
        this.$showImage(rep.data.url)
        return
      }
      if (file.fileName.indexOf('pdf') !== -1) {
        let fileRep = await axios.get(rep.data.url, { responseType: 'blob' })
        let blob = new Blob([fileRep.data])
        let fileUrl = window.URL.createObjectURL(blob)
        window.open('pdf/web/viewer.html?file=' + fileUrl)
        return
      }
      window.open(rep.data.url)
    },
    cancelImport() {
      this.importCompanyId = ''
      this.supplierInputForm.companyName = ''
      this.supplierInputForm.companyNo = ''
      this.supplierInputForm.companyAddress = ''
      this.supplierInputForm.companyTel = ''
      this.supplierInputForm.companyMail = ''
      this.supplierInputForm.LegalPerson = ''
      this.supplierInputForm.LegalPersonTel = ''
      this.importMode = false
    },
    importCompany(company) {
      this.importCompanyId = company.id
      this.supplierInputForm.companyName = company.companyName
      this.supplierInputForm.companyNo = company.companyNo
      this.supplierInputForm.companyAddress = company.companyAddress
      this.supplierInputForm.companyTel = company.companyTel
      this.supplierInputForm.companyMail = company.companyMail
      this.supplierInputForm.LegalPerson = company.legalPerson
      this.supplierInputForm.LegalPersonTel = company.legalPersonTel
      this.companyChooseVisible = false
      this.importMode = true
    },
    async importArticle(article) {
      if (this.importProjectStatus === 'projects') {
        this.articleData = {
          id: '',
          objectId: article.id,
          amount: article.entryFee,
          title: article.projectName,
          projectNo: article.projectFull,
          projectShort: article.projectShort,
          district: article.district
        }
      }
      if (this.importProjectStatus === 'articles') {
        this.articleData = {
          id: article.id,
          objectId: article.objectId,
          amount: article.amount,
          title: article.title,
          projectNo: article.projectNo,
          projectShort: article.projectShort,
          district: article.areas
        }
      }
      this.articleChooseVisible = false
      this.spinShow('正在导入公告信息')

      try {
        let rep = await ajax.get(requestUrls.ClGroupDb.getPaged, {
          params: {
            filter: `projectId == ${this.articleData.objectId}`,
            sorting: 'id',
            maxResultCount: 500,
            skipCount: 0
          }
        })
        this.groupList = rep.data.result.items
        this.$Spin.hide()
        this.enrollFormVisible = true
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
      }
    },
    inputEnroll() {
      this.$refs.supplierInputForm.validate(async valid => {
        if (valid) {
          this.$Spin.show()
          // 检测是否重复录入
          let repeatEnrollRep = await ajax.get(requestUrls.enroll.getPaged, {
            params: {
              filter: `e.companyName == "${this.supplierInputForm.companyName}" and e.projectId == "${this.articleData.objectId}"`,
              maxResultCount: 1,
              skipCount: 0
            }
          })
          this.$Spin.hide()
          if (repeatEnrollRep.data.result.items.length > 0) {
            this.$Modal.confirm({
              title: '重复录入',
              content: '此项目已录入此公司的报名信息，是否再次录入？',
              onOk: () => {
                this.enterEnroll()
              }
            })
            return
          }

          this.enterEnroll()

        }
      })
    },
    async enterEnroll() {
      this.spinShow('正在录入数据，请稍后..')
      try {
        // 更新或添加公司信息
        const companyData = {
          "id": this.importCompanyId,
          "companyNo": this.supplierInputForm.companyNo,
          "companyName": this.supplierInputForm.companyName,
          // "companyType": this.supplierInputForm.companyType,
          "companyTel": this.supplierInputForm.companyTel,
          "companyAddress": this.supplierInputForm.companyAddress,
          "companyMail": this.supplierInputForm.companyMail,
          "legalPerson": this.supplierInputForm.LegalPerson,
          "legalPersonTel": this.supplierInputForm.LegalPersonTel
        }
        let companyRep = await userAjax.post(requestUrls.company.createOrUpdate, { abpCompany: companyData })
        let companyId = '';
        if (companyRep.data.success) {
          companyId = companyRep.data.result.id
        }

        let gainEmail = ''
        if (this.supplierInputForm.gainMode === '3') {
          let gainEmail = this.supplierInputForm.companyMail
        }

        // 添加报名
        let abpEnrollExt = []
        this.groupList.forEach(group => {
          if (this.supplierInputForm.groupArr.indexOf(group.id) !== -1) {
            abpEnrollExt.push({
              projectId: this.articleData.objectId,
              groupId: group.id,
              groupNumber: group.groupNo,
              groupName: group.groupName,
            })
          }
        })
        const enrollData = {
          "projectId": this.articleData.objectId,
          "groupId": this.supplierInputForm.groupArr.join(','),
          "companyId": companyId,
          "projectContact": this.supplierInputForm.projectContact,
          "projectPhone": this.supplierInputForm.projectPhone,
          "projectMail": '',
          "projectFax": this.supplierInputForm.projectFax,
          "transactor": this.supplierInputForm.transactor,
          "transactorPhone": this.supplierInputForm.transactorPhone,
          "openAccount": this.supplierInputForm.openAccount,
          "openBank": this.supplierInputForm.openBank,
          "gainMode": this.supplierInputForm.gainMode,
          "gainEmail": gainEmail,
          "articlesId": this.articleData.id,
          "status": "1", // 1 状态待付费
          "companyAddress": this.supplierInputForm.companyAddress,
          "companyMail": this.supplierInputForm.companyMail,
          "companyName": this.supplierInputForm.companyName,
          "companyNo": this.supplierInputForm.companyNo,
          "companyTel": this.supplierInputForm.companyTel,
          "legalPerson": this.supplierInputForm.LegalPerson,
          "legalPersonTel": this.supplierInputForm.LegalPersonTel,
          "projectShort": this.articleData.projectShort,
          "projectFull": this.articleData.projectNo,
          "district": this.articleData.district,
          "abpEnrollExt": abpEnrollExt
        }
        let enrollRep = await ajax.post(requestUrls.enroll.createOrUpdate, { abpEnroll: enrollData })
        // 获得enrollId
        if (enrollRep.data.success) {
          this.enrollFormVisible = false
          // 重置支付方式
          this.paymentType = ''
          // 重置证明文件
          this.paymentFileArr = []
          this.orderList = []
          this.enrollPriceShow = true
          this.enrollRepData = enrollRep.data.result
        }
        this.$Spin.hide()
      } catch (err) {
        this.$Spin.hide()
        console.error(err)
      }
    },
    async setPayment() {
      if (this.enrollTab === '线上支付') {
        if (this.orderList.length == 0) {
          this.$Message.error('请先完成支付')
          return
        }
      }
      if (this.enrollTab === '缴费证明文件') {
        if (this.isUnion && this.companyName === '') {
          this.$Message.error('请输入收款公司')
          return
        }
        if (this.isUnion && this.companyNo === '') {
          this.$Message.error('请输入信用代码')
          return
        }
        if (isNaN(parseInt(this.articleData.amount))) {
          this.$Message.error('请输入报名费（数字）')
          return
        }
        if (this.articleData.amount > 9999) {
          this.$Message.error('报名费不得超过9999元，请重新输入')
          return
        }
        if (this.paymentType === '') {
          this.$Message.error('请选择收款方式')
          return
        }
        if (this.payTimeValue === '') {
          this.$Message.error('请选择收款时间')
          return
        }
        if (this.realPayTime === '') {
          this.$Message.error('请选择实际到账时间')
          return
        }
      }
      if (!this.selectAccount || this.selectAccount === '') {
        this.$Message.error('请选择收款账号')
        return
      }
      if (this.articleData.amount >= 5000 && !this.confirmServeCharge) {
        this.$Modal.confirm({
            title: '报名费确认',
            content: '当前报名费大于5000元，请确认信息无误',
            onOk: () => {
              this.confirmServeCharge = true
            },
            onCancel: () => {}
        });
      } else {
        this.confirmPayment()
      }
    },
    confirmPayment() {
      this.$Modal.confirm({
        title: '报名费审核',
        content: '确认审核通过',
        onOk: async () => {
          this.$Spin.show()
          let district = this.selectAccountData.district
          if (district === '军工事业部') {
            district = '广州'
          }
          if (this.selectAccountData.xhfCompanyName === '广东采联采购科技有限公司湛江分公司') {
            district = '广州'
          }
          let ghfCompanyName = this.isUnion ? this.companyName : this.enrollRepData.companyName
          let ghfInvoiceTaxNo = this.isUnion ? this.companyNo : this.enrollRepData.companyNo

          if (this.enrollTab === '线上支付') {
            let order = this.orderList.filter(item => item.orderStatus != '0' && item.orderStatus != '4')
            if(order.length == 0) {
              this.$Spin.hide()
              this.$Message.error('非线上支付或线上支付已退款，请选择缴费证明文件方式审核')
              return
            }
            // 订单修改
            ajax.put('/api/services/app/AbpOrders/UpdateAbpOrders',{
              id: order[0].id,
              orderNo: order[0].orderNo,
              redOrderNo: order[0].redOrderNo,
              orderStatus: order[0].orderStatus,
              orderAmountTotal: order[0].orderAmountTotal,
              payChannel: order[0].payChannel,
              outTradeNo: order[0].outTradeNo,
              payTime: order[0].payTime,
              realPayTime: order[0].realPayTime,
              orderType: order[0].orderType,
              debitAndCredit: order[0].debitAndCredit,
              ghfInvoiceTaxNo: order[0].ghfInvoiceTaxNo,
              ghfCompanyName: order[0].ghfCompanyName,
              ghfCompanyAddress: order[0].ghfCompanyAddress,
              ghfTelphone: order[0].ghfTelphone,
              ghfBankName: order[0].ghfBankName,
              ghfBankAccount: order[0].ghfBankAccount,
              xhfInvoiceTaxNo: this.selectAccountData.xhfInvoiceTaxNo,
              xhfCompanyName: this.selectAccountData.xhfCompanyName,
              xhfCompanyAddress: this.selectAccountData.xhfCompanyAddress,
              xhfTelphone: this.selectAccountData.xhfTelphone,
              xhfBankName: this.selectAccountData.xhfBankName,
              xhfBankAccount: this.selectAccountData.xhfBankAccount,
              marginSeqNo: order[0].marginSeqNo,
              ybId: order[0].ybId,
              projectFull: order[0].projectFull,
              district: district,
              confirm: order[0].confirm,
              isInvoice: order[0].isInvoice,
              projectId: order[0].projectId,
              flowStatus: order[0].flowStatus,
              dataSource: order[0].dataSource,
              remark: order[0].remark
            }).then(() => {
              // 修改报名状态
              this.enrollRepData.status = '3'
              ajax.post(requestUrls.enroll.createOrUpdate, {
                abpEnroll: this.enrollRepData
              }).then(async () => {
                this.$Spin.hide()
                this.enrollPriceShow = false
                this.$Message.success('已通过')
              })
            }).catch(err => {
              this.$Spin.hide()
              this.$Message.error('通过失败')
            })
          }
          if (this.enrollTab === '缴费证明文件') {
            // 生成订单。默认已付费
            try {
              // 生成订单
              let rep = await ajax.post(requestUrls.order.CreateOrders, {
                enrollId: this.enrollRepData.id,
                orderAmountTotal: this.articleData.amount,
                orderStatus: '2', // 2状态订单已付费
                orderType: '报名',
                ghfInvoiceTaxNo: ghfInvoiceTaxNo,
                ghfCompanyName: ghfCompanyName,
                ghfCompanyAddress: this.enrollRepData.companyAddress,
                ghfTelphone: this.enrollRepData.companyTel,
                ghfBankName: this.enrollRepData.openBank,
                ghfBankAccount: this.enrollRepData.openAccount,
                xhfInvoiceTaxNo: this.selectAccountData.xhfInvoiceTaxNo,
                xhfCompanyName: this.selectAccountData.xhfCompanyName,
                xhfCompanyAddress: this.selectAccountData.xhfCompanyAddress,
                xhfTelphone: this.selectAccountData.xhfTelphone,
                xhfBankName: this.selectAccountData.xhfBankName,
                xhfBankAccount: this.selectAccountData.xhfBankAccount,
                projectFull: this.enrollRepData.projectFull,
                district: district,
                projectId: this.enrollRepData.projectId,
                ordersExp: {
                  bankName: this.realPayAccountName,
                  bankAccount: this.realPayAccount,
                }
              })
              if (rep.data.success) {
                // 修改报名状态
                this.enrollRepData.status = '3'
                let enrollRep = await ajax.post(requestUrls.enroll.createOrUpdate, {
                  abpEnroll: this.enrollRepData
                })
  
                // 修改支付时间
                let payTimeRep = await ajax.put(requestUrls.order.updateOrdersPay, {
                  id: rep.data.result.id,
                  payChannel: this.paymentType,
                  payTime: this.getPaytime(this.payTimeValue),
                  realPayTime: this.getPaytime(this.realPayTime),
                  orderAmountTotal: this.articleData.amount
                })
                // 调整订单发票关联
                if (this.enrollRepData.ordersDto && this.enrollRepData.ordersDto.remark === '信息修改') {
                  await ajax.post(requestUrls.orderInvoice.InvoiceMigrate, {
                    oldOrderNo: this.enrollRepData.ordersDto.redOrderNo,
                    newOrderNo: rep.data.result.orderNo
                  })
                }
  
                this.$Spin.hide()
                if (enrollRep.data.success) {
                  this.changeEnroll(this.currentPage, this.searchValue)
                  this.enrollPriceShow = false
                  this.confirmServeCharge = false
                  this.$Message.success('报名费缴付成功')
                } else {
                  this.$Message.error('报名费缴付失败')
                }
              }
            } catch (err) {
              console.error(err)
              this.$Spin.hide()
              this.$Message.error('报名费缴付失败')
            }
          }
          // 短信通知采购人
          // 获取项目信息
          ajax.get(`/api/services/app/ClProjectDb/GetById?id=${this.enrollRepData.projectId}`).then(res => {
            let projectData = res.data.result
            // 是否政府采购项目
            if (projectData.projectProperty === '政府采购') {
              // 委托协议
              ajax.get(requestUrls.CLTrustAgreementInfo.GetPaged, {
                params: {
                  filter: `projectId == ${projectData.id}`
                }
              }).then(async (agreement) =>{
                if (agreement.data.result.totalCount && agreement.data.result.items[0].ifKnow === '可以获悉') {
                  let typeParams = {
                    phone: agreement.data.result.items[0].partyAContactNumber,
                    content: `尊敬的${projectData.purchaserName} - ${agreement.data.result.items[0].partyAContact}：您好！ 您的${projectData.projectName}项目有供应商报名成功，单位名称：${this.enrollRepData.companyName}，请知悉！`
                  }
                  await sendMessage('phoneContent', typeParams)
                }
              })
            }
          })
        }
      })
    },
    async setPaymentIn() {
      if (this.paymentType === '') {
        this.$Message.error('请选择收款方式')
        return
      }
      if (this.selectAccount === '') {
        this.$Message.error('请选择收款账号')
        return
      }
      if (isNaN(parseInt(this.articleData.amount))) {
        this.$Message.error('请输入报名费（数字）')
        return
      }
      this.$Modal.confirm({
        title: '报名费审核',
        content: '确认审核通过（不开发票）',
        onOk: async () => {
          // 生成订单。默认已付费
          this.$Spin.show()
          try {
            // 生成订单
            let rep = await ajax.post(requestUrls.order.ProjectCreateOrders, {
              enrollId: this.enrollRepData.id,
              orderAmountTotal: this.articleData.amount,
              orderStatus: '2', // 2状态订单已付费
              orderType: '报名',
              "ghfInvoiceTaxNo": this.enrollRepData.companyNo,
              "ghfCompanyName": this.enrollRepData.companyName,
              "ghfCompanyAddress": this.enrollRepData.companyAddress,
              "ghfTelphone": this.enrollRepData.companyTel,
              "ghfBankName": this.enrollRepData.openBank,
              "ghfBankAccount": this.enrollRepData.openAccount,
              "xhfInvoiceTaxNo": this.selectAccountData.xhfInvoiceTaxNo,
              "xhfCompanyName": this.selectAccountData.xhfCompanyName,
              "xhfCompanyAddress": this.selectAccountData.xhfCompanyAddress,
              "xhfTelphone": this.selectAccountData.xhfTelphone,
              "xhfBankName": this.selectAccountData.xhfBankName,
              "xhfBankAccount": this.selectAccountData.xhfBankAccount,
              "projectFull": this.enrollRepData.projectFull,
              "district": this.enrollRepData.district,
              "projectId": this.enrollRepData.projectId,
              "ordersExp": {
                "bankName": this.realPayAccountName,
                "bankAccount": this.realPayAccount,
              }
            })
            if (rep.data.success) {
              // 修改报名状态
              this.enrollRepData.status = '3'
              let enrollRep = await ajax.post(requestUrls.enroll.createOrUpdate, {
                abpEnroll: this.enrollRepData
              })

              // 修改支付时间
              let payTimeRep = await ajax.put(requestUrls.order.updateOrdersPay, {
                id: rep.data.result.id,
                payChannel: this.paymentType,
                payTime: this.getPaytime(this.payTimeValue),
                realPayTime: this.getPaytime(this.realPayTime),
                orderAmountTotal: this.articleData.amount
              })
              this.$Spin.hide()
              if (enrollRep.data.success) {
                this.changeEnroll(this.currentPage, this.searchValue)
                this.enrollPriceShow = false
                this.$Message.success('报名费缴付成功')
              } else {
                this.$Message.error('报名费缴付失败')
              }
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('报名费缴付失败')
          }
        }
      })
    },
    unpassPayment() {
      // this.enrollRepData
      this.$Modal.confirm({
        title: '缴费审核不通过',
        content: '请仔细确认供应商上传缴费证明，确认不通过？',
        onOk: async () => {
          this.enrollRepData.status = '5'
          let enrollRep = await ajax.post(requestUrls.enroll.createOrUpdate, {
            abpEnroll: this.enrollRepData
          })
          if (enrollRep.data.success) {
            this.changeEnroll(this.currentPage, this.searchValue)
            this.enrollPriceShow = false
            this.$Message.success('审核成功')
            // 刷新列表
          } else {
            this.$Message.error('审核失败')
          }
        }
      })
    },
    examineUnpass() {
      this.sentEmail = false
      this.$Modal.confirm({
        title: '审核不通过',
        render: (h) => {
          return h('div', {}, [
            h('div', {
              style: {
                display: 'flex',
                margin: '10px 0'
              }
            }, [
              h('Icon', { props: {
                type: 'help-circled',
                size: '40',
                color: "#ff9200"
              },style:{
                width: '28%'
              }}),
              h('p', {}, `供应商${this.enrollRepData.companyName}报名${this.enrollRepData.articles.title}审核不通过`),
            ]),
            h('div', {}, [
              h('Input', { 
                props: {
                  autofocus: true,
                  placeholder: '请填写不通过原因',
                  value: this.enrollRepData.remark
                },
                on: {
                  input: (val) => {
                    this.enrollRepData.remark = val
                  }
                }
              }),
              h('Checkbox', {
                style: {
                  marginTop: '10px',
                  float: 'right'
                },
                on: {
                  'on-change':(val)=>{
                    this.sentEmail = val
                  }
                }
              }, '是否发送邮箱通知'),
            ])
          ])
        },
        onOk: async() => {
          if (this.enrollRepData.remark) {
            if (this.sentEmail) {
              // 接收邮件通知
              let typeParams = {
                title: '报名审核不通过——采联集团',
                toMail: this.enrollRepData.companyMail,
                content: `尊敬的${this.enrollRepData.companyName}供应商：您报名的${this.enrollRepData.articles.title}项目资料审核不通过。具体原因：${this.enrollRepData.remark}。请登录报名系统修改资料重新提交。（报名系统：http://suppliers.chinapsp.cn）`
              }
              this.$Spin.show()
              let rep = await sendMessage('emailContent', typeParams)
              this.$Spin.hide()
              if (rep) {
                this.$Message.success('邮件发送成功')
              } else {
                this.$Message.error('邮件发送失败')
              }
            }
            try {
              // 更新状态
              this.enrollRepData.status = '2'
              let enrollRep = await ajax.post(requestUrls.enroll.createOrUpdate, {
                abpEnroll: this.enrollRepData
              })
              if (enrollRep.data.success) {
                this.changeEnroll(this.currentPage, this.searchValue)
                this.examineConfirmVisible = false
                this.$Message.success('审核成功')
              } else {
                this.$Message.error('审核失败')
              }
            } catch (err) {
              console.error(err)
              this.$Message.error('审核失败')
            }
          } else {
            this.$Message.error('请填写审核不通过原因')
            setTimeout(() => {
              this.examineUnpass()
            },300)
          }
        }
      })
    },
    examinePass() {
      this.$Modal.confirm({
        title: '审核通过',
        content: `<p>供应商${this.enrollRepData.companyName}报名${this.enrollRepData.articles.title}审核通过</p>`,
        onOk: async () => {
          try {
            // 更新状态
            this.enrollRepData.remark = ''
            this.enrollRepData.status = '1'
            let enrollRep = await ajax.post(requestUrls.enroll.createOrUpdate, {
              abpEnroll: this.enrollRepData
            })
            if (enrollRep.data.success) {
              this.changeEnroll(this.currentPage, this.searchValue)
              this.examineConfirmVisible = false
              this.$Message.success('审核成功')
            } else {
              this.$Message.error('审核失败')
            }
          } catch (err) {
            console.error(err)
            this.$Message.error('审核失败')
          }
        }
      })
    },
    async invoiceAndRefund(enroll) {
      this.invoiceEnroll = enroll
      await this.getOrders(enroll)
      this.ordersVisible = true
    },
    async getOrders(enroll) {
      this.spinShow('正在查询缴费记录..')
      try {
        let rep = await ajax.get(requestUrls.order.getPaged, {
          params: {
            filter: `enrollId == "${enroll.id}" and ( orderType == "报名" or orderType == "邮费" or orderType == "图纸费" or orderType == "投标费")`,
            maxResultCount: 100,
            skipCount: 0,
            sorting: 'creationTime'
          }
        })
        if (rep.data.success) {
          // 过滤未付款订单
          this.orderList = rep.data.result.items.filter(item => item.orderStatus != '1' && item.orderStatus != '5')
        }
        this.$Spin.hide()
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
      }
    },
    // 开电子发票
    makeInvoice(order) {
      if (!order.isInvoice) {
        this.$Message.error('此订单不能开发票（报名审核时已选择不开发票！）')
        return
      }
      // 选择开票方式
      this.$Modal.confirm({
        render: (h) => {
          return [h('span', {
            style: {
              margin: '10px'
            }
          }, '请选择开票方式：'), h('RadioGroup', {
            props: {
              type: 'button'
            },
            on: {
              'on-change': (val) => {
                this.makeInvoiceType = val
              }
            }
          }, [
              h('Radio', {
                props: {
                  label: '电子发票'
                }
              }),
              h('Radio', {
                props: {
                  label: '录入发票'
                }
              }),
            ])]
        },
        onOk: () => {
          if (this.makeInvoiceType === '') {
            this.$Message.error('请选择发票类型')
            return
          }
          // 电子发票权限
          if (!this.invoicePermission && this.makeInvoiceType === '电子发票') {
            this.$Message.error('无电子发票权限')
            return
          }
          if (this.makeInvoiceType === '电子发票') {
            this.isHandle = false
            this.invoiceData = order
            this.makeInvoiceVisible = true
          }
          if (this.makeInvoiceType === '录入发票') {
            this.isHandle = true
            this.invoiceData = order
            this.makeInvoiceVisible = true
          }
        },
        onCancel: () => {
          this.makeInvoiceType = ''
        }
      })
    },
    async showInvoice(order) {
      this.orderData = order
      await this.getInvoiceList(order)
      this.invoiceListVisible = true
    },
    async getInvoiceList(order) {
      this.spinShow('正在获取发票信息..')
      let rep = await ajax.get(requestUrls.orderInvoice.getPaged, {
        params: {
          filter: `orderNo == "${order.orderNo}"`,
          maxResultCount: 100,
          skipCount: 0,
        }
      })
      this.$Spin.hide()
      this.invoiceList = []
      if (rep.data.success) {
        this.invoiceList = rep.data.result.items
      }
    },
    async sendInvoiceMessage(invoiceData, order, type) {
      // let result = invoiceData
      if (invoiceData.inputMode === '电子发票') {
        if (!invoiceData.pdfUrl) {
          this.$Message.info('未有生成发票，请先尝试点击更新')
          return false
        }

        if (type === 'mail') {
          this.$Modal.confirm({
            title: '发送邮箱',
            content: '是否发出获取发票地址的邮箱信息？',
            onOk: async () => {
              let typeParams = {
                title: '电子发票获取——采联集团',
                toMail: this.invoiceEnroll.companyMail,
                content: `尊敬的${this.invoiceEnroll.companyName}供应商：您的电子发票已开出,地址是${invoiceData.pdfUrl}。【采联集团】`
              }
              this.$Spin.show()
              let rep = await sendMessage('emailContent', typeParams)
              this.$Spin.hide()
              if (rep) {
                this.$Message.success('发送成功')
              } else {
                this.$Message.error('发送失败')
              }
            }
          })
        }

        if (type === 'phone') {
          this.$Modal.confirm({
            title: '发送短信',
            content: '是否发出获取发票地址的短信信息？',
            onOk: async () => {
              let typeParams = {
                phone: this.invoiceEnroll.projectPhone,
                content: `尊敬的${this.invoiceEnroll.companyName}供应商：您的电子发票已开出,地址是${invoiceData.pdfUrl}。`
              }
              this.$Spin.show()
              let rep = await sendMessage('phoneContent', typeParams)
              this.$Spin.hide()
              if (rep) {
                this.$Message.success('发送成功')
              } else {
                this.$Message.error('发送失败')
              }
            }
          })
        }

      } else {
        this.$Message.error('非电子发票')
      }
    },
    finishInvoice() {
      this.makeInvoiceVisible = false
      this.refreshOrders()
    },
    // 刷新订单列表
    async refreshOrders() {
      let rep = await ajax.get(requestUrls.order.getPaged, {
        params: {
          filter: `enrollId == "${this.invoiceEnroll.id}" and ( orderType == "报名" or orderType == "邮费" or orderType == "投标费")`,
          maxResultCount: 100,
          skipCount: 0,
          sorting: 'creationTime'
        }
      })
      if (rep.data.success) {
        this.orderList = rep.data.result.items
      }
    },
    async addToOldSys(order) {
      if (!order.isInvoice || order.ybId) {
        this.$Message.info('已添加财务流')
        return
      }
      try {
        // 查询当前订单是否开发票
        let rep = await ajax.get(requestUrls.orderInvoice.getPaged, {
          params: {
            filter: `orderNo == "${order.orderNo}"`,
            maxResultCount: 1,
            skipCount: 0
          }
        })
        if (rep.data.result.items.length > 0) {
          this.$Modal.confirm({
            title: '添加财务流',
            content: '确定添加此数据至财务流？（不可撤回）',
            onOk: async () => {
              this.$Spin.show()
              try {
                let rep = await ajax.post(requestUrls.order.OrdersConfirm + `?orderId=${order.id}`)
                // let rep = await ajax({
                //   type: 'POST',
                //   url: requestUrls.order.OrdersConfirm + `orderId=${order.id}`,
                //   params: {
                //     orderId: order.id
                //   }
                // })
                this.$Spin.hide()
                if (rep.data.success) {
                  this.$Message.success('操作成功')
                  // 刷新订单
                  this.refreshOrders()
                } else {
                  this.$Message.error('操作失败')
                }
              } catch (err) {
                console.error(err)
                this.$Spin.hide()
                this.$Message.error('操作失败')
              }
            }
          })
        } else {
          this.$Message.info('请先开发票才能添加财务流')
        }
      } catch (err) {
        console.error(err)
        this.$Message.error('操作失败')
      }
    },
    // 无发票直接退款
    directRefund() {
      if (this.refundReason == '') {
        this.$Message.error('请选择退款原因')
        return
      }
      // 修改原订单状态
      this.$Modal.confirm({
        title: '退款',
        content: '是否确认退款',
        onOk: async () => {
          try {
            this.$Spin.show()
            // 修改原订单状态
            let orderRep = ajax.put(requestUrls.order.updateOrder, {
              id: this.orderData.id,
              orderStatus: '4'
            })
            // 生成退款订单
            let rep = await ajax.post(requestUrls.order.CreateOrders, {
              enrollId: this.orderData.enrollId,
              orderAmountTotal: -this.orderData.orderAmountTotal,
              orderStatus: '0', // 0状态红冲订单
              orderType: this.orderData.orderType,
              redOrderNo: this.orderData.orderNo,
              payChannel: this.orderData.payChannel,
              payTime: formatDate(this.refundTime),
              ghfInvoiceTaxNo: this.orderData.ghfInvoiceTaxNo,
              ghfCompanyName: this.orderData.ghfCompanyName,
              ghfCompanyAddress: this.orderData.ghfCompanyAddress,
              ghfTelphone: this.orderData.ghfTelphone,
              ghfBankName: this.orderData.ghfBankName,
              ghfBankAccount: this.orderData.ghfBankAccount,
              xhfInvoiceTaxNo: this.orderData.xhfInvoiceTaxNo,
              xhfCompanyName: this.orderData.xhfCompanyName,
              xhfCompanyAddress: this.orderData.xhfCompanyAddress,
              xhfTelphone: this.orderData.xhfTelphone,
              xhfBankName: this.orderData.xhfBankName,
              xhfBankAccount: this.orderData.xhfBankAccount,
              projectFull: this.orderData.projectFull,
              district: this.orderData.district,
              projectId: this.orderData.projectId,
              ordersExp: {
                bankName: '',
                bankAccount: '',
              },
              remark: this.refundReason
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('退款成功')
              this.refundInfoVisible = false
              // 刷新订单
              this.refreshOrders()
              // 修改报名状态
              if (this.feeTypes.indexOf(this.orderData.orderType) === -1) {
                this.invoiceEnroll.status = '1'
                let enrollRep = await ajax.post(requestUrls.enroll.createOrUpdate, {
                  abpEnroll: this.invoiceEnroll
                })
              }
              // 刷新报名状态
              this.changeEnroll(this.currentPage, this.searchValue)
            } else {
              this.$Message.error('退款失败')
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('退款失败')
          }
        }
      })
    },
    // 退款
    async refund(order) {
      if(!order.xhfCompanyName) {
        this.$Message.error('请先确认收款')
        return
      }
      this.orderData = order
      // 直接退款，不管是否开票
      // this.directRefund()
      this.refundInfoVisible = true
      // return
      // if (order.orderStatus === '2') {
      //   // this.$Message.error('请先开具发票')
      //   // 进入直接退款流程
      //   this.directRefund()
      //   return
      // }
      // this.$Spin.show()
      // // 查询当前正票类型
      // let rep = await ajax.get(requestUrls.orderInvoice.getPaged, {
      //   params: {
      //     filter: `orderNo == "${order.orderNo}"`,
      //     maxResultCount: 1,
      //     skipCount: 0
      //   }
      // })
      // this.$Spin.hide()
      // if (rep.data.result.items[0].inputMode === '录入发票') {
      //   this.invoiceInputMode = '录入发票'
      // } else if (rep.data.result.items[0].inputMode === '电子发票') {
      //   this.invoiceInputMode = '电子发票'
      // }
      // if (order.orderStatus === '3') {
      //   this.$Modal.confirm({
      //     title: '退款',
      //     content: '是否开出红冲发票退款？',
      //     onOk: () => {
      //       this.redInvoiceVisible = true
      //     }
      //   })
      // }
    },
    makeRedInvoice() {
      if (this.invoiceInputMode === '录入发票') {
        if (this.redInvoiceHm === '' || !this.redInvoiceHm) {
          this.$Message.error('发票号码不能为空')
          return
        }
        if (this.redInvoiceTime === '' || !this.redInvoiceTime) {
          this.$Message.error('发票时间不能为空')
          return
        }
      }
      if (this.redInvoiceMaker === '' || !this.redInvoiceMaker) {
        this.$Message.error('开票人姓名不能为空')
        return
      }
      if (this.redInvoicePayee === '' || !this.redInvoicePayee) {
        this.$Message.error('收款人姓名不能为空')
        return
      }
      if (this.redInvoiceCheck === '' || !this.redInvoiceCheck) {
        this.$Message.error('复核人姓名不能为空')
        return
      }
      this.$Modal.confirm({
        title: '提示',
        content: '即将开出红冲发票，此操作无法撤回，请注意',
        onOk: async () => {
          this.spinShow('正在开票，请稍后..')
          try {
            // 开票
            let rep = {}
            if (this.invoiceInputMode === '录入发票') {
              let invoiceTime = formatDate()
              rep = await ajax.post(requestUrls.orderInvoice.ManualRedInvoice, {
                invoiceHm: this.redInvoiceHm,
                invoiceTime: invoiceTime,
                // orderNo: this.orderData.orderNo,
                idplus: this.selectInvoice.id,
                kpr: this.redInvoiceMaker,
                skr: this.redInvoicePayee,
                fhr: this.redInvoiceCheck,
              })
            } else if (this.invoiceInputMode === '电子发票') {
              // 根据发票类型判断红冲发票是南航发票还是诺诺发票
              const parameter = {
                idplus: this.selectInvoice.id,
                kpr: this.redInvoiceMaker,
                skr: this.redInvoicePayee,
                fhr: this.redInvoiceCheck,
              }
              if (this.selectInvoice.invoiceSource === '诺诺') {
                rep = await ajax.post(requestUrls.orderInvoice.NnCreateRedInvoice, parameter)
              } else {
                rep = await ajax.post(requestUrls.orderInvoice.CreateRedInvoice, parameter)
              }
              // rep = await ajax.post(requestUrls.orderInvoice.CreateRedInvoice, {
              //   // orderNo: this.orderData.orderNo,
              //   idplus: this.selectInvoice.id,
              //   kpr: this.redInvoiceMaker,
              //   skr: this.redInvoicePayee,
              //   fhr: this.redInvoiceCheck,
              // })
            }
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('操作成功')
              this.redInvoiceVisible = false
              this.getInvoiceList(this.orderData)
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('操作失败')
          }
        }
      })
    },
    cancelExaminePay(val) {
      if (!val) {
        // 刷新报名列表（报名录入需要）
        this.changeEnroll(this.currentPage, this.searchValue)
        // 清空付款账号
        this.selectAccount = ''
        this.selectAccountData = ''
        // 重置支付方式
        this.paymentType = ''
        this.realPayAccountName = ''
        this.realPayAccount = ''
        this.isGroupCal = false
        this.reEnrollFree = false
      } else {
        this.payTimeValue = new Date()
      }
    },
    cancelPostage(val) {
      if (!val) {
        this.extraFee = ''
        this.feeType = ''
        // 清空付款账号
        this.selectAccount = ''
        this.selectAccountData = ''
        // 重置支付方式
        this.paymentType = ''
      }
    },
    getPaytime(val) {
      // 添加支付时间
      let proTime = new Date(val).getTime()
      proTime = formatDate(proTime)
      return proTime
    },
    async setPostageOrder() {
      if (this.feeType === '') {
        this.$Message.error('请选择费用类型')
        return
      }
      if (isNaN(parseInt(this.extraFee))) {
        this.$Message.error('请输入金额（数字）')
        return
      }
      if (this.paymentType === '') {
        this.$Message.error('请选择收款方式')
        return
      }
      if (this.selectAccount === '' || !this.selectAccountData.xhfCompanyName) {
        this.$Message.error('请选择收款账号')
        return
      }
      this.$Spin.show()
      try {
        // 生成订单
        let district = this.selectAccountData.district
        if (district === '军工事业部' || (district === '湛江' && this.enrollRepData.projectFull.indexOf('CLZ') === -1)) {
          district = '广州'
        }
        let rep = await ajax.post(requestUrls.order.CreateOrders, {
          enrollId: this.enrollRepData.id,
          orderAmountTotal: this.extraFee,
          orderStatus: '2', // 已收费
          orderType: this.feeType,
          "ghfInvoiceTaxNo": this.enrollRepData.companyNo,
          "ghfCompanyName": this.enrollRepData.companyName,
          "ghfCompanyAddress": this.enrollRepData.companyAddress,
          "ghfTelphone": this.enrollRepData.companyTel,
          "ghfBankName": this.enrollRepData.openBank,
          "ghfBankAccount": this.enrollRepData.openAccount,
          "xhfInvoiceTaxNo": this.selectAccountData.xhfInvoiceTaxNo,
          "xhfCompanyName": this.selectAccountData.xhfCompanyName,
          "xhfCompanyAddress": this.selectAccountData.xhfCompanyAddress,
          "xhfTelphone": this.selectAccountData.xhfTelphone,
          "xhfBankName": this.selectAccountData.xhfBankName,
          "xhfBankAccount": this.selectAccountData.xhfBankAccount,
          "projectFull": this.enrollRepData.projectFull,
          "district": district,
          "projectId": this.enrollRepData.projectId,
          "ordersExp": {
            "bankName": this.realPayAccountName,
            "bankAccount": this.realPayAccount,
          }
        })
        this.$Spin.hide()
        if (rep.data.success) {

          this.$Message.success('添加费用成功')
          this.postageVisible = false

          // 修改支付时间方式
          let payTimeRep = await ajax.put(requestUrls.order.updateOrdersPay, {
            id: rep.data.result.id,
            payChannel: this.paymentType,
            payTime: this.getPaytime(this.payTimeValue),
            realPayTime: this.getPaytime(this.realPayTime),
            orderAmountTotal: this.extraFee
          })
        }
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('添加费用失败')
      }
    },
    changePStatus(val) {
      if (val) {
        this.importProjectStatus = 'projects'
      } else {
        this.importProjectStatus = 'articles'
      }
    },
    selectTimeChange(val) {
      this.searchValue.searchPayTime = val
    },
    exportData(type) {
      if (type === 'sellFile') {
        window.open(`${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2FSupplierOrder%2FSupplierOrder.cpt&op=write`)
      }
      if (type === 'enrollFile') {
        window.open(`${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian/分公司售卖情况一览表/sale.cpt`)
      }
    },
    async showArticle(row) {
      if (!row.articlesId) {
        this.$Message.error('项目录入，无公告')
        return
      }
      this.spinShow('正在获取公告内容')
      try {
        let rep = await ajax.get(requestUrls.articlesData.GetArticleDataByAIdAsync, {
          params: {
            aid: row.articlesId
          }
        })
        this.$Spin.hide()
        if (rep.data.success) {
          this.articleContent = rep.data.result.content
          this.articleVisible = true
        } else {
          this.$Message.error('获取公告失败')
        }
      } catch (err) {
        this.$Spin.hide()
        console.error(err)
        this.$Message.error('获取公告失败')
      }
    },
    reviseEnrollInfo() {
      // this.enrollRepData
      if (this.reviseInfo.companyName === '') {
        this.$Message.error('公司名称不能为空')
        return
      }
      if (this.reviseInfo.companyNo === '') {
        this.$Message.error('信用代码不能为空')
        return
      }
      // if (!CheckSocialCreditCode(this.reviseInfo.companyNo)) {
      //   this.$Message.error("不是有效的统一社会信用编码！")
      //   return
      // }
      if (this.reviseInfo.groupArr.length === 0) {
        this.$Message.error('包组不能为空')
        return
      }

      this.$Modal.confirm({
        title: '资料修改',
        content: '确定修改此公司报名资料信息？',
        onOk: async () => {
          this.enrollRepData.companyName = this.reviseInfo.companyName
          this.enrollRepData.companyNo = this.reviseInfo.companyNo
          this.enrollRepData.companyAddress = this.reviseInfo.companyAddress
          this.enrollRepData.companyMail = this.reviseInfo.companyMail
          this.enrollRepData.projectContact = this.reviseInfo.projectContact
          this.enrollRepData.projectPhone = this.reviseInfo.projectPhone

          // 添加报名包组
          let abpEnrollExt = []
          this.groupList.forEach(group => {
            if (this.reviseInfo.groupArr.indexOf(group.id) !== -1) {
              abpEnrollExt.push({
                projectId: this.enrollRepData.projectId,
                groupId: group.id,
                groupNumber: group.groupNo,
                groupName: group.groupName,
              })
            }
          })
          this.enrollRepData.abpEnrollExt = abpEnrollExt
          this.enrollRepData.groupId = this.reviseInfo.groupArr.join(',')

          try {
            this.$Spin.show()
            let rep = await ajax.post(requestUrls.enroll.createOrUpdate, {
              abpEnroll: this.enrollRepData
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('修改成功')
              // 刷新列表
              this.changeEnroll(this.currentPage, this.searchValue)
              this.reviseInfoVisible = false
            } else {
              this.$Message.error('修改失败')
            }
          } catch (err) {
            this.$Spin.hide()
            this.$Message.error('修改失败')
          }
        }
      })
    },
    editInvoiceData() {
      this.$Modal.confirm({
        title: '修改发票信息',
        content: '确定修改此发票信息',
        onOk: async () => {
          let invoiceTime = ''
          if (this.invoiceEdit.invoiceDate) {
            invoiceTime = formatDate(this.invoiceEdit.invoiceDate)
          }
          this.$Spin.show()
          try {
            let rep = await ajax.post(requestUrls.orderInvoice.ModifyInvoiceNumber, {
              id: this.selectInvoice.id,
              invoiceHm: this.invoiceEdit.invoiceHm,
              invoiceTime: invoiceTime,
              invoiceAmount: this.invoiceEdit.invoiceAmount
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.invoiceEditVisible = false
              this.$Message.success('操作成功')
              this.getInvoiceList(this.orderData)
              
            } else {
              this.$Message.error('操作失败')
            }
          } catch (err) {
            this.$Spin.hide()
            console.error(err)
            this.$Message.error('操作失败')
          }
        }
      })
    },
    editOrderData() {
      this.$Modal.confirm({
        title: '修改订单信息',
        content: '确定修改订单信息？',
        onOk: async () => {
          let payTime = ''
          if (this.orderEdit.orderTime) {
            payTime = formatDate(this.orderEdit.orderTime)
          }
          this.$Spin.show()
          try {
            const reviseOrder = Object.assign({}, this.reviseOrder, {
              payChannel: this.orderEdit.payType,
              payTime: payTime,
              orderAmountTotal: this.orderEdit.orderAmount,
              ghfCompanyName: this.orderEdit.ghfCompanyName,
              ghfInvoiceTaxNo: this.orderEdit.ghfInvoiceTaxNo,
            })
            // let rep = await ajax.put(requestUrls.order.updateOrdersPay, {
            //   id: this.reviseOrder.id,
            //   payChannel: this.orderEdit.payType,
            //   payTime: payTime,
            //   orderAmountTotal: this.orderEdit.orderAmount,
            // })
            let rep = await ajax.put('/api/services/app/AbpOrders/UpdateAbpOrders', reviseOrder)
            this.$Spin.hide()
            if (rep.data.success) {
              this.orderEditVisible = false
              // this.ordersVisible = false
              this.$Message.success('修改成功')
              this.getOrders(this.invoiceEnroll)
              // this.changeEnroll(this.currentPage, this.searchValue)
            } else {
              this.$Message.error('修改失败')
              this.$Spin.hide()
            }
          } catch (err) {
            this.$Message.error('修改失败')
            this.$Spin.hide()
          }
        }
      })
    },
    reviseComment() {
      if (!this.enrollComment) {
        this.$Message.error('备注信息不能为空')
        return
      }
      this.$Modal.confirm({
        title: '修改备注',
        content: '确定修改备注信息？',
        onOk: async () => {
          this.$Spin.show()
          try {
            this.enrollRepData.remark = this.enrollComment
            let rep = await ajax.post(requestUrls.enroll.createOrUpdate, {
              abpEnroll: this.enrollRepData
            })
            this.$Spin.hide()
            if (rep.data.success) {
              this.$Message.success('操作成功')
            } else {
              this.$Message.error('操作失败')
            }
          } catch (err) {
            console.error(err)
            this.$Spin.hide()
            this.$Message.error('操作失败')
          }
        }
      })
    },
    async marginConfirm () {
      this.$Spin.show()
      try {
        this.enrollRepData.openId = this.guarantee
        let rep = await ajax.post(requestUrls.enroll.createOrUpdate, {
          abpEnroll: this.enrollRepData
        })
        this.$Spin.hide()
        if (rep.data.success) {
          this.$Message.success('操作成功')
          this.editMarginVisible = false
        } else {
          this.$Message.error('操作失败')
        }
      } catch (err) {
        console.error(err)
        this.$Spin.hide()
        this.$Message.error('操作失败')
      }
    },
    getFile(url) {
      return new Promise((resolve, reject) => {
        axios.get(url, {
          responseType: 'arraybuffer'
        }).then(data => {
          resolve(data.data)
        }).catch(error => {
          reject(error.toString())
        })
      })
    },
    downloadFiles() {
      let files = []
      let zip = new jszip()
      const promises = []
      const cache = {}
      // 下载文件 获取文件地址
      this.enrollDbFiles.forEach((file,index) => {
        fileUtil.downLoad(file.ossId).then(res => {
          files.push(res)
          if (index === this.enrollDbFiles.length - 1) {
            files.forEach(item => {
              const promise = this.getFile(item).then(data => { // 下载文件, 并存成ArrayBuffer对象
              const arr_name = item.split("/");
              let file_name = arr_name[arr_name.length - 1] // 获取文件名
              file_name = file_name.slice(file_name.lastIndexOf('%3D') + 3)
              zip.file(file_name, data, {
                binary: true
              }) // 逐个添加文件
              cache[file_name] = data
            })
              promises.push(promise)
            })
            Promise.all(promises).then(() => {
              zip.generateAsync({
                type: "blob"
              }).then(content => { // 生成二进制流
                FileSaver.saveAs(content, "Documents.zip") // 利用file-saver保存文件
              })
            })
          }
        })
      })
      
    },
    // 获取采购文件
    getBiddingFile(param) {
      this.fileModal = true
      ajax.get(requestUrls.AbpAliOss.GetListByObjectId,{
        params: {
          objectId: param.projectId,
          objectIdType: 'enroll'
        }
      }).then(res => {
        let arr = res.data.result.items.filter(item => item.fileType == '2')
        if (arr.length > 0) this.biddingFile = arr[arr.length - 1]
      })
    },
    async downloadBiddingFile(type) {
      let { fileName, bucket, id } = this.biddingFile
      let res = ''
      if (bucket === 'chinapsp-resource') {
        res = await localFile.getPermanentDownUrl(bucket, fileName)
      }
      if (bucket === 'clneiwang') {
        let clrep = await ajax.get(requestUrls.AbpAliOss.GetDownUrl, {
          params: {
            id
          }
        })
        res = clrep.data.result
      }
      if (type == 'down') { window.open(res) }
      if (type == 'send') {
        this.$Modal.confirm({
          title: '发送邮件',
          content: `确定发送采购文件电子版至${this.enrollRepData.companyMail}邮箱吗？`,
          onOk: () => {
            this.$Spin.show()
            // 获取项目信息
            ajax.get(`/api/services/app/ClProjectDb/GetById`,{
              params: {
                id: this.enrollRepData.projectId
              }
            }).then(async(project) => {
              // 发送邮件
              let date = new Date()
              let year = date.getFullYear(); 
              let month = date.getMonth() + 1; 
              let day = date.getDate();
              let typeParams = {
                title: '采购文件电子版——采联集团',
                toMail: this.enrollRepData.companyMail,
                content: `<p>尊敬的${this.enrollRepData.companyName}供应商：</p>` + 
                          `<div style="text-indent: 2em">贵司在采联集团获取文件系统上关于${project.data.result.projectName}项目报名成功,采购文件电子版为：<a href="${res}" download="${this.biddingFile.displayName}">${this.biddingFile.displayName}</a>。<span>（部分邮箱会拦截下载，弹出页面请点击继续访问即可下载）</span></span></div>` +
                          `<p style="text-align: right"> 采联国际招标采购集团有限公司</p>` + 
                          `<div style="text-align: right">  ${year}年${month}月${day}日</div>`
              }
              let rep = await sendMessage('emailContent', typeParams)
              if (rep) {
                this.$Spin.hide()
                this.$Message.success('邮件发送成功')
                this.fileModal = false
              } else {
                this.$Spin.hide()
                this.$Message.error('邮件发送失败')
              }
            })
          },
          onCancel: () => {}
        })
      }
    },
    tabsChange() {
      this.paymentType = ''
      this.selectAccount = ''
      this.selectAccountData=''
    },
    sendEmail() {
      if(this.emailContent == '') {
        this.$Message.error('不能发送空消息！')
        return
      }
      this.$Modal.confirm({
        title: '发送邮件',
        content: `确定发送邮件至${this.enrollRepData.companyMail}邮箱吗？`,
        onOk: () => {
          let date = new Date()
          let year = date.getFullYear()
          let month = date.getMonth() + 1
          let day = date.getDate()
          let typeParams = {
            title: '报名通知——采联集团',
            toMail: this.enrollRepData.companyMail,
            content: `<p>尊敬的${this.enrollRepData.companyName}供应商：</p>` + 
                    `<div style="text-indent: 2em">${this.emailContent}</div>` + 
                    `<div style="text-indent: 2em">项目名称：${this.enrollRepData.articles.title},详情请登录报名系统查看项目信息。（报名系统：http://suppliers.chinapsp.cn）</div>` + 
                    `<p style="text-align: right"> 采联国际招标采购集团有限公司</p>` + 
                    `<div style="text-align: right">  ${year}年${month}月${day}日</div>`
          }
          sendMessage('emailContent', typeParams)
          this.editEmail = false
          this.$Message.success('发送成功')
        },
        onCancel: () => {}
      })
    }
  },
  components: {
    CompanyChoose,
    ArticleChoose,
    Invoice,
    ProjectChoose
  }
}
</script>

<style lang="less">
.search-wrapper {
  margin: 5px;
  .search {
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
  }
  .input-enroll {
    width: 100px;
    display: inline-block;
  }
}
#input-form {
  .item-half {
    width: 50%;
  }
  td {
    border: 1px solid #cecece;
  }
  table {
    border: 1px solid #cecece;
  }
  .ivu-input {
    border: 0;
  }
  .ivu-form-item {
    margin-bottom: 0;
  }
  .ivu-form-item-error-tip {
    left: auto;
    top: 5px;
    right: -55px;
  }
  .valid-email {
    .ivu-form-item-error-tip {
      right: -90px;
    }
  }
  .project-group {
    .ivu-form-item-label {
      padding-bottom: 30px;
    }
    .ivu-form-item-error-tip {
      left: -75px;
      top: 30px;
    }
  }
  .ivu-checkbox-group {
    label {
      display: inline-block;
      width: 100%;
    }
  }
}
.enroll-files {
  li {
    list-style: none;
    display: inline-block;
    margin-left: 10px;
    margin-top: 10px;
  }
  .ivu-card-body {
    padding-top: 0;
  }
}
.ivu-modal {
  top: 50px;
}
.workbreak {
  display: inline-block;
  width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.redinvoice-item {
  padding: 5px;
}
</style>